<template>
  <div id="dashboard-analytics">
    <vs-popup classContent="popup-example" title="Are You Sure You Want To Send SMS?" :active.sync="showPassportFontPop"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row" style="float: right;margin-right: 0px;" @click="dismissPOPPassportFront()">
          <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
            style="background: rgb(0, 0, 0);color: white;">close</i>
        </div>
        <div v-if="viewPdfFlag || viewPdfFlagOne">
          <vue-pdf-viewer style="height: 600px;width: 600px;" :url="viewPassportImage">
          </vue-pdf-viewer>
        </div>
        <div v-else>
          <v-img max-width="600" :src="viewPassportImage" style="margin:10px;"></v-img>
        </div>
      </div>
    </vs-popup>
    <vs-alert :active.sync="alert" closable icon-pack="feather" close-icon="icon-x" color="danger" title="ERROR!!!"
      style="text-align: center" @click="dismissError()">
      {{ alertMessage }}
    </vs-alert>
    <div v-if="selectedTypeEntity === 'Company'" class="row" style="margin-top: 20px;margin-left:0px;">
      <div v-for="(profile, index) in secondaryProfileList">
        <b-button variant="none"
          style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
          :class="{ buttonActiveNew: selectedButton == index }" @click="changeActive(index)">
          Director {{ index + 1 }}
        </b-button>
      </div>

      <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
        style="display: flex;margin-left: 20px;" @click="addNewDirectorClick()" v-show="showOnceBtn">
        <feather-icon style="height: 16px;width: 16px;" icon="UserPlusIcon" class="mr-50" />
        <div class="align-middle">Add Director</div>
      </b-button>
    </div>
    <div v-else class="row" style="margin-top: 20px;margin-left:0px;">
      <div v-for="(profile, index) in secondaryProfileList">
        <b-button variant="none"
          style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
          :class="{ buttonActiveNew: selectedButton == index }" @click="changeActive(index)">
          Partner {{ index + 1 }}
        </b-button>
      </div>

      <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
        style="display: flex;margin-left: 20px;" @click="addNewDirectorClick()" v-show="showOnceBtn">
        <feather-icon style="height: 16px;width: 16px;" icon="UserPlusIcon" class="mr-50" />
        <div class="align-middle">Add Partner</div>
      </b-button>
    </div>

    <div v-if="NewDirectorFlag">
      <vx-card style="padding: 0px;margin-top : 28px">
        <div class="row" style="border-bottom: 1px solid rgba(34, 41, 47, 0.125);bottom: 10px;">
          <span class="col-4 w-full" style="font-size: 18px; color: #5e5873; font-weight: 500;margin-bottom:10px;">
            Basic Details
          </span>

          <div class="col-8 w-full" style="text-align: right;bottom: 10px;">
            <b-button @click="createKycId()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-primary" style="padding: 5px 5px;
  width: 100px;font-size:11px;">
              <feather-icon icon="SaveIcon" style="width:16px" class="mr-50" />
              <span class="align-middle" style="vertical-align: super !important;font-size: 14px;">Save</span>
            </b-button>
          </div>
        </div>

        <b-row style="padding-top: 10px; padding-bottom: 28px">
          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Name </span><br />
            <input type="text" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter Name" v-model="custNameNew" style="width: 90%;font-size:12px;"
              @input="val => (custNameNew = custNameNew.toUpperCase())" />
            <label class="control-label" style="
              font-family: 'montserratregular';
              font-size: 12px;
              color: red;
              text-align: center;


            " v-show="errorcustNameNew">
              {{ errorcustNameMsgNew }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Shareholding Percentage </span><br />
            <input type="number" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter Percentage" v-model="custShareHoldingNew" style="width: 90%;font-size:12px;"
              onKeyPress="if(this.value.length==3) return false;" />
            <label class="control-label" style="
              font-family: 'montserratregular';
              font-size: 12px;
              color: red;
              text-align: center;


            " v-show="errorcustShareHoldingNew">
              {{ errorcustShareHoldingMsgNew }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px" v-if="custType === 'Company'">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Director Identification No(DIN) </span><br />
            <input type="number" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter DIN" v-model="custDINNew" style="width: 90%;font-size:12px;"
              onKeyPress="if(this.value.length==8) return false;" />
            <label class="control-label" style="
              font-family: 'montserratregular';
              font-size: 12px;
              color: red;
              text-align: center;


            " v-show="errorcustDINNew">
              {{ errorcustDINMsgNew }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px" v-if="custType === 'Company'">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Appointment Date </span><br />

            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="CalendarIcon" />
              </b-input-group-prepend>
              <flat-pickr v-model="custAptDateNew" class="form-control" placeholder="Select DOB"
                style="font-size:12px;" />
            </b-input-group>

            <label class="control-label" style="
              font-family: 'montserratregular';
              font-size: 12px;
              color: red;
              text-align: center;


            " v-show="errorcustAptDateNew">
              {{ errorcustAptDateMsgNew }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Contact Number </span><br />
            <div style="width: 90%;" class="form-control">
              <div class="row">
                <img src="../../assets/icons/IndianFlag.png" style="height: 10px;
    width: 16px;
    margin-top: 8px;
    margin-left: 10px;" />
                <label style="padding-top:5px">+91</label>
                <input type="number" style="border: none;padding-left:10px;width:60%;font-size: 12px;
    color: #5e5873;
    font-weight: 400;" placeholder="Enter Number" v-model="custcontactNoNew"
                  onKeyPress="if(this.value.length==10) return false;" />
              </div>
            </div>
            <label class="control-label" style="
              font-family: 'montserratregular';
              font-size: 12px;
              color: red;
              text-align: center;


            " v-show="errorcustcontactNoNew">
              {{ errorcustcontactNoMsgNew }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Email Id </span><br />
            <b-form-input type="text" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter Email Id" v-model="custEmailidNew" style="width: 90%;font-size:12px;" />

            <label class="control-label" style="
          font-family: 'montserratregular';
          font-size: 12px;
          color: red;
          text-align: center;


        " v-show="errorcustEmailidNew">
              {{ errorcustEmailidMsgNew }}
            </label>
          </b-col>
        </b-row>
      </vx-card>
      <!-- <router-view ref="routerView" @setAppClasses="setAppClasses" /> -->

      <br />

      <vx-card style="padding:0px">
        <div v-if="panNo.length > 0">
          <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
            <span class="col-6 w-full" style="font-size: 18px; color: #5e5873; font-weight: 500;margin-bottom:10px;">
              Identity Proof
            </span>
          </b-row>
        </div>

        <div v-else>
          <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
            <span class="col-6 w-full" style="font-size: 18px; color: #5e5873; font-weight: 500;margin-bottom:10px;">
              Identity Proof
            </span>

            <div class="col-6 w-full" style="text-align: right;bottom: 10px;">
              <b-button @click="fetchPanDetailsNew()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-primary"
                style="padding: 5px 5px;
width: 100px;font-size:11px;">
                <feather-icon icon="RefreshCwIcon" style="width:16px" class="mr-50" />
                <span class="align-middle" style="vertical-align: super !important;font-size:14px;">Fetch</span>
              </b-button>
            </div>
          </b-row>
        </div>

        <div>
          <b-row>
            <b-form-group class="col-3" label="Business PAN Number"
              style="font-size:12px;color: #b9b9c3; font-weight: 400;margin-top:10px;">
              <b-form-input type="text" class="form-control" id="task" required="required" name="repayinfo"
                placeholder="Enter PAN No" v-model="panNumber" style="width: 90%;font-size:12px;"
                @input="val => (panNumber = panNumber.toUpperCase())" />
              <label class="control-label" style="
            font-family: 'montserratregular';
            font-size: 12px;
            color: red;
            text-align: center;


          " v-show="errorPan">
                {{ errorPanMsg }}
              </label>
            </b-form-group>

            <b-form-group class="col-3" label="Date of Birth"
              style="font-size:12px;color: #b9b9c3; font-weight: 400;margin-top:10px;">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="CalendarIcon" />
                </b-input-group-prepend>
                <flat-pickr v-model="dob" class="form-control" placeholder="Select DOB" style="font-size:12px;" />
              </b-input-group>
            </b-form-group>

            <b-col md="4" style="padding-top: 7px">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Identity Proof </span><br />

              <div class="row" style="margin-left: 0px;margin-top: 7px;" v-if="currentAddressName.length > 0">
                <!-- <input
        class="form-control"
        id="task"
        required="required"
        name="repayinfo"
        placeholder="Enter pincode"
        v-model="currentpostalcode"


      /> -->
                <input type="file" ref="files" style="display: none" v-on:change="handleFileUploadTwo()" />
                <img src="../../assets/icons/clipIcon.png" style="height: 18px;margin-top: 5px" />

                <b-button @click="$refs.files.click()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-none"
                  style="padding:0px;font-size:11px;margin-left: 10px;">
                  <span v-if="currentAddressName.length > 0" style="font-size:12px;">{{ currentAddressName }}</span>
                  <span style="width: 80%;font-size:12px;" v-else-if="fileNameSet.length > 0">{{ fileNameSet }}</span>
                  <span v-else style="white-space: nowrap;">Upload address proof</span>
                </b-button>

                <b-button @click="uploadDocument()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-dark"
                  style="border-color: #4328AE !important;
  color: #4328AE !important;font-size: 11px;height: 30px;">
                  <div class="row" style="margin:auto;">
                    <img src="../../assets/icons/uploadNew.png" style="margin-right:5px" />Upload
                  </div>
                </b-button>
              </div>
              <div class="row" style="margin-left: 0px;margin-top: 7px;" v-else>
                <div style="width:55%;border: 1px solid;
height: 2.714rem;border-radius: 5px;border-color: rgb(185, 185, 195);">
                  <input type="file" ref="files" style="display: none" v-on:change="handleFileUploadOne()" />
                  <!-- <select name="status" id="status" v-model="typeOfBusinessSelected" class="form-control" style="font-size: 12px; color: #5e5873; font-weight: 500;Width:90%;">
  <option  v-for="business in buissnessEntityType"  :value="business.value"> {{business.text}} </option>

</select> -->
                  <div class="row" style="width: 100%;margin-left: 10px;margin-top: 8px;" @click="$refs.files.click()">
                    <label style="width: 80%;font-size:12px;" v-if="fileNameSet.length > 0">{{ fileNameSet }}</label>
                    <label style="width: 80%;color: rgb(185, 185, 195);white-space: nowrap;" v-else>Upload Address
                      Proof</label>

                    <img src="../../assets/icons/uploadFileIcon.png"
                      style="height: 15px;margin-top: 1px;margin-left: 5px;" />
                  </div>
                </div>
              </div>
              <label class="control-label" style="
          font-family: 'montserratregular';
          font-size: 12px;
          color: red;
          text-align: center;


        " v-show="uploadAddressFlag">
                {{ uploadAddressMessage }}
              </label>
            </b-col>
          </b-row>
        </div>
      </vx-card>
      <br />

      <vx-card style="padding: 0px;margin-top : 28px">
        <div>
          <b-row style="
          border-bottom: 1px solid #ebe9f1;" class="row">
            <span class="col-4 w-full" style="font-size: 18px; color: #5E5873; font-weight: 500;bottom: 10px;">
              Address Proof
            </span>
          </b-row>

          <br />
          <!-- <div v-if="poaData.length > 0 && ovdAddressType ==='Digio-driving_license'">

      <b-row
        style="
            border-bottom: 1px solid #ebe9f1;

            padding-bottom: 28px;

          "

      >

      <b-col md="2" style="padding-top: 10px" v-if="drivingDigioRetrieveNumber != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Licence No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ drivingDigioRetrieveNumber }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Licence No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>

      <b-col md="2" style="padding-top: 10px" v-if="drivingDigioRetrieveName">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ drivingDigioRetrieveName }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>

      <b-col md="2" style="padding-top: 10px" v-if="drivingDigioRetrieveDob">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ drivingDigioRetrieveDob }}
        </span>
      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>
      </b-col>
        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCO }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioStreet }}
          </span>
        </b-col>



        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioLocality != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLocality }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCity }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioDistrict != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioDistrict }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioState }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioPin }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLand }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>


          <b-col md="12" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Permanent Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              {{ drivingDigioRetrievePermAdd }}
            </span>

          </b-col>

      </b-row>
    </div>




      <div v-else-if="poaData.length > 0 && ovdAddressType ==='Digio-passport'">
      <b-row
        style="
            border-bottom: 1px solid #ebe9f1;

            padding-bottom: 28px;

          "

      >

      <b-col md="2" style="padding-top: 10px" v-if="passportRetrieveNumber != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Passport No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ passportRetrieveNumber }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Passport No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


      <b-col md="2" style="padding-top: 10px" v-if="passportRetrieveName != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ passportRetrieveName }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>



      <b-col md="2" style="padding-top: 10px" v-if="passportDOB != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ passportDOB }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


      <b-col md="2" style="padding-top: 10px" v-if="passportFatherName != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Father Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ passportFatherName }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Father Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>






      <b-col md="2" style="padding-top: 10px" v-if="passportMotherName">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Mother Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ passportMotherName }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Mother Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCO }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioStreet }}
          </span>
        </b-col>



        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioLocality != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLocality }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCity }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioDistrict != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioDistrict }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioState }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioPin }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLand }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>


          <b-col md="12" style="padding-top: 10px" v-if="passportRetrievePermAdd">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Permanent Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              {{ passportRetrievePermAdd }}
            </span>

          </b-col>
          <b-col md="12" style="padding-top: 10px" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Permanent Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              __ __
            </span>

          </b-col>

      </b-row>
    </div>



      <div v-else-if="poaData.length > 0 && ovdAddressType ==='Digio-voter_id'">
      <b-row
        style="
            border-bottom: 1px solid #ebe9f1;

            padding-bottom: 28px;

          "

      >

      <b-col md="2" style="padding-top: 10px" v-if="voterRetrieveNumber != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          VoterID No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ voterRetrieveNumber }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          VoterID No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


      <b-col md="2" style="padding-top: 10px" v-if="voterRetrieveName != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ voterRetrieveName }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>



      <b-col md="2" style="padding-top: 10px" v-if="voterDOB != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ voterDOB }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


      <b-col md="2" style="padding-top: 10px" v-if="voterFatherName != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Father Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ voterFatherName }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Father Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>






      <b-col md="2" style="padding-top: 10px" v-if="voterGender">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Gender </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ voterGender }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Gender </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


      <b-col md="2" style="padding-top: 10px" v-if="voterDateOfIssue">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date Of Issue </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ voterDateOfIssue }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date Of Issue </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCO }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioStreet }}
          </span>
        </b-col>



        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioLocality != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLocality }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCity }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioDistrict != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioDistrict }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioState }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioPin }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLand }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>


          <b-col md="12" style="padding-top: 10px" v-if="voterRetrievePermAdd">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Permanent Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              {{ voterRetrievePermAdd }}
            </span>

          </b-col>
          <b-col md="12" style="padding-top: 10px" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Permanent Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              __ __
            </span>

          </b-col>

      </b-row>
    </div>



      <div v-else-if="poaData.length > 0 && ovdAddressType ==='Physical-aadhar'">
      <b-row
        style="
            border-bottom: 1px solid #ebe9f1;

            padding-bottom: 28px;

          "

      >

      <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveNumber != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Aadhaar No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ physicalRetrieveNumber }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Aadhaar No </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


      <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveName != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ physicalRetrieveName }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Name </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>



      <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveDOB != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ physicalRetrieveDOB }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          DOB (YYYY-MM-DD) </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>


      <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveGender != ''">
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Gender </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          {{ physicalRetrieveGender }}
        </span>


      </b-col>
      <b-col md="2" style="padding-top: 10px" v-else>
        <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Gender </span
        ><br />
        <span
          style="font-size: 12px; color: #5e5873; font-weight: 500"

        >
          __ __
        </span>


      </b-col>












        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCO }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Care of </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioStreet }}
          </span>
        </b-col>



        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Street Name </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioLocality != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLocality }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Locality </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioCity }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            City </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col
          md="2"
          style="padding-top: 10px"
          v-if="drivingDigioDistrict != ''"
        >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioDistrict }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            District </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioState }}
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            State </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioPin }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Pincode </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ drivingDigioLand }}
          </span>
        </b-col>
        <b-col md="2" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Landmark </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>


          <b-col md="6" style="padding-top: 10px;border-right: 1px solid #ebe9f1;" v-if="physicalRetrievePermAdd">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Permanent Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              {{ physicalRetrievePermAdd }}
            </span>

          </b-col>
          <b-col md="6" style="padding-top: 10px;border-right: 1px solid #ebe9f1;" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Permanent Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              __ __
            </span>

          </b-col>


          <b-col md="6" style="padding-top: 10px" v-if="physicalRetrieveCorresAdd">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Correspondence Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              {{ physicalRetrieveCorresAdd }}
            </span>

          </b-col>
          <b-col md="6" style="padding-top: 10px" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Correspondence Address </span
            ><br />
            <span
              style="font-size: 12px; color: #5e5873; font-weight: 500"

            >
              __ __
            </span>

          </b-col>

      </b-row>
    </div> -->

          <div>
            <b-row style="align-items: center;">
              <div style="    margin-left: 145px;">
                <img src="../../assets/icons/directorAddressFrame.png" alt="login" class="mx-auto" />
              </div>

              <div class="col-7" style="margin-left: 10px;">
                <span style="font-size: 15px; color: #5e5873; font-weight: 500">
                  No Address Proof available<br />
                  Please upload Address Proof to view details
                </span>
                <br />
                <div class="row" style="padding-left: 14px;margin-top: 20px;">
                  <select name="status" id="status" v-model="typeOfAddressProofNew" class="form-control"
                    style="font-size: 12px; color: #5e5873; font-weight: 500;width: 200px;color:#4328AE;border-color:#4328AE;">
                    <option value=""> Select Address Proof </option>
                    <option value="POA_DL"> Driving Licence </option>
                    <option value="POA_PASSPORT"> Passport </option>
                    <option value="POA_VOTERID"> Voter ID </option>
                    <option value="POA_AADHAAR"> Aadhaar </option>
                  </select>
                  <b-button @click="createKYCRequestNEW()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                    style="margin-left: 10px">
                    Upload
                  </b-button>
                </div>
                <span id="loanLimitErr" style="color: #a94442;font-size: 12px;" v-show="phoneFlag">
                  {{ phoneFlagMessage }}</span>
                <br />

                <div class="row" style="padding-left: 14px;margin-top: 10px;">
                  <img src="../../assets/icons/lockIcon.png" alt="login" style="width: 15px;
    height: 15px;" />
                  <div style="color:#9E9E9E;font-weight:500;margin-left:8px;margin-right: 8px;font-size: 12px;">
                    You will be redirected to a secured URL to
                    <br />upload Address Proof
                  </div>

                  <div style="color:#9E9E9E;font-weight:500;margin-left:8px;margin-right: 8px;font-size: 12px;">
                    Powered by
                    <br />
                    <img src="../../assets/icons/digioImg.png" alt="login" />
                  </div>
                </div>
                <!-- <b-button
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            variant="outline-primary"
            style="margin-left:60px;border: 1px solid #7367F0;white-space: nowrap;width: 170px;margin-top: 10px;"
            @click="ekycClick()"
          >
            eKYC
          </b-button> -->
              </div>
            </b-row>
          </div>
        </div>
      </vx-card>
    </div>

    <div v-else>
      <vx-card style="padding: 0px;margin-top : 28px">
        <div class="row" style="border-bottom: 1px solid rgba(34, 41, 47, 0.125);bottom: 10px;">
          <span class="col-4 w-full" style="font-size: 18px; color: #5e5873; font-weight: 500;margin-bottom:10px;">
            Basic Details
          </span>

          <div class="col-8 w-full" style="text-align: right;bottom: 10px;">
            <b-button v-if="basicDetAvail === false" @click="storeCustType()" v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="outline-primary" style="padding: 5px 5px;
width: 100px;font-size:11px;">
              <feather-icon icon="SaveIcon" style="width:16px" class="mr-50" />
              <span class="align-middle" style="vertical-align: super !important;font-size: 14px;">Save</span>
            </b-button>
            <div v-else>
              <feather-icon icon="EditIcon" style="top: 7px;left: 15px;color: #4328AE !important;width:15px;" />

              <b-button @click="editAddress()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-none"
                style="color: #4328AE !important;">
                Edit
              </b-button>
            </div>
          </div>
        </div>

        <b-row style="padding-top: 10px; padding-bottom: 28px" v-if="basicDetAvail">
          <b-col md="2" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Name </span><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 400">
              {{ custName }}
            </span>
          </b-col>
          <b-col md="2" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Shareholding Percentage </span><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 400">
              {{ custShareHolding }}
            </span>
          </b-col>
          <b-col md="2" style="padding-top: 10px" v-if="custType === 'Company'">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Director Identification No(DIN) </span><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 400">
              {{ custDIN }}
            </span>
          </b-col>
          <b-col md="2" style="padding-top: 10px" v-if="custType === 'Company'">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Appointment Date </span><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 400">
              {{ custAptDate }}
            </span>
          </b-col>

          <b-col md="2" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Contact Number </span><br />
            <div>
              <div class="row" style="margin: auto;white-space: nowrap;">
                <img style="width: 16px;height: 10px;margin-top:3px;" src="../../assets/icons/IndianFlag.png" />
                <div style="font-size:12px;olor: #5e5873;
          font-weight: 400;">
                  +91
                </div>

                <div style="font-size: 12px;
          color: #5e5873;
          font-weight: 400;margin-left: 5px;">
                  {{ custcontactNo }}
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="2" style="padding-top: 10px" v-if="custEmailid">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Email Id </span><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 400">
              {{ custEmailid }}
            </span>
          </b-col>
          <b-col md="2" style="padding-top: 10px" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Email Id </span><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 400">
              __ __
            </span>
          </b-col>
        </b-row>

        <b-row style="padding-top: 10px; padding-bottom: 28px" v-else>
          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Name </span><br />
            <input type="text" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter Name" v-model="custName" style="width: 90%;font-size:12px;"
              @input="val => (custName = custName.toUpperCase())" />
            <label class="control-label" style="
            font-family: 'montserratregular';
            font-size: 12px;
            color: red;
            text-align: center;


          " v-show="errorcustName">
              {{ errorcustNameMsg }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Shareholding Percentage </span><br />
            <input type="number" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter Percentage" v-model="custShareHolding" style="width: 90%;font-size:12px;"
              onKeyPress="if(this.value.length==3) return false;" />
            <label class="control-label" style="
            font-family: 'montserratregular';
            font-size: 12px;
            color: red;
            text-align: center;


          " v-show="errorcustShareHolding">
              {{ errorcustShareHoldingMsg }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px" v-if="custType === 'Company'">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Director Identification No(DIN) </span><br />
            <input type="number" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter DIN" v-model="custDIN" style="width: 90%;font-size:12px;"
              onKeyPress="if(this.value.length==8) return false;" />
            <label class="control-label" style="
            font-family: 'montserratregular';
            font-size: 12px;
            color: red;
            text-align: center;


          " v-show="errorcustDIN">
              {{ errorcustDINMsg }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px" v-if="custType === 'Company'">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Appointment Date </span><br />

            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="CalendarIcon" />
              </b-input-group-prepend>
              <flat-pickr v-model="custAptDate" class="form-control" placeholder="Select DOB" style="font-size:12px;" />
            </b-input-group>

            <label class="control-label" style="
            font-family: 'montserratregular';
            font-size: 12px;
            color: red;
            text-align: center;


          " v-show="errorcustAptDate">
              {{ errorcustAptDateMsg }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Contact Number </span><br />
            <div style="width: 90%;" class="form-control">
              <div class="row">
                <img src="../../assets/icons/IndianFlag.png" style="height: 10px;
  width: 16px;
  margin-top: 8px;
  margin-left: 10px;" />
                <label style="padding-top:5px">+91</label>
                <input type="number" style="border: none;padding-left:10px;width:60%;font-size: 12px;
  color: #5e5873;
  font-weight: 400;" placeholder="Enter Number" v-model="custcontactNo"
                  onKeyPress="if(this.value.length==10) return false;" />
              </div>
            </div>
            <label class="control-label" style="
            font-family: 'montserratregular';
            font-size: 12px;
            color: red;
            text-align: center;


          " v-show="errorcustcontactNo">
              {{ errorcustcontactNoMsg }}
            </label>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
              Email Id </span><br />
            <b-form-input type="text" class="form-control" id="task" required="required" name="repayinfo"
              placeholder="Enter Email Id" v-model="custEmailid" style="width: 90%;font-size:12px;" />

            <label class="control-label" style="
        font-family: 'montserratregular';
        font-size: 12px;
        color: red;
        text-align: center;


      " v-show="errorcustEmailid">
              {{ errorcustEmailidMsg }}
            </label>
          </b-col>
        </b-row>
      </vx-card>
      <!-- <router-view ref="routerView" @setAppClasses="setAppClasses" /> -->

      <br />

      <vx-card style="padding:0px">
        <div v-if="panNo.length > 0">
          <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
            <span class="col-6 w-full" style="font-size: 18px; color: #5e5873; font-weight: 500;margin-bottom:10px;">
              Identity Proof
            </span>
          </b-row>
        </div>

        <div v-else>
          <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
            <span class="col-6 w-full" style="font-size: 18px; color: #5e5873; font-weight: 500;margin-bottom:10px;">
              Identity Proof
            </span>

            <div class="col-6 w-full" style="text-align: right;bottom:10px;">
              <b-button @click="fetchPanDetails()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-primary"
                style="padding: 5px 5px;
width: 100px;font-size:11px;">
                <feather-icon icon="RefreshCwIcon" style="width:16px" class="mr-50" />
                <span class="align-middle" style="vertical-align: super !important;font-size:14px;">Fetch</span>
              </b-button>
            </div>
          </b-row>
        </div>
        <div v-if="poiData.length > 0">
          <b-row style="
        border-bottom: 1px solid #ebe9f1;
        padding-top: 10px;
        padding-bottom: 28px;
      ">
            <b-col md="2" style="padding-top: 10px" v-if="panNo.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Pan No </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ panNo }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Pan No </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-if="panStatus === 'VALID'">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Pan Status </span><br />
              <span style="font-size: 12px; color: #97C93E; font-weight: 400">
                {{ panStatus }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Pan Status </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ panStatus }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-if="panTitle.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Title </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ panTitle }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Title </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-if="panName.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ panName }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-if="panFirstName.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                First Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ panFirstName }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                First Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-if="panMiddleName.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Middle Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ panMiddleName }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Middle Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-if="panLastName.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Last Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ panLastName }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Last Name </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-if="typeOfHolder.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Type of Holder </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ typeOfHolder }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Type of Holder </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-if="aadharStatus.length > 0">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Aadhar Seeding Status </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                {{ aadharStatus }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Aadhar Seeding Status </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 400">
                Last Updated on </span><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 400">
                __ __
              </span>
            </b-col>
          </b-row>

          <div v-if="showOttheBusiProof">
            <b-row style="
    border-bottom: 1px solid #ebe9f1;
    padding-top: 28px;
    padding-bottom: 28px;
  ">
              <b-col class="col" style="padding-top: 10px; margin: auto">
                <div class="row" v-if="showOttheBusiProof">
                  <div v-if="viewPdfFlag">
                    <vue-pdf-viewer style="height: 150px;width: 100px;" :url="obusinessDownUrl">
                    </vue-pdf-viewer>
                  </div>
                  <div v-else>
                    <v-img max-height="40" max-width="60" :src="obusinessDownUrl"></v-img>
                  </div>
                  <div style="font-size:12px;margin-left: 10px;margin-top: 20px;" v-if="viewPdfFlag">
                    {{ odocumentType }} <br /><feather-icon icon="EyeIcon"
                      style="height: 15px;width: 15px;color:#4328AE;cursor:pointer;"
                      @click="viewPassportFront(obusinessDownUrl)" /><feather-icon icon="DownloadIcon"
                      style="height: 15px;width: 15px;margin-left: 10px;color:#4328AE;cursor:pointer;"
                      @click="downloadPassFront(obusinessDownUrl)" />
                  </div>
                  <div style="font-size:12px;margin-left: 10px;" v-else>
                    {{ odocumentType }} <br /><feather-icon icon="EyeIcon"
                      style="height: 15px;width: 15px;color:#4328AE;cursor:pointer;"
                      @click="viewPassportFront(obusinessDownUrl)" /><feather-icon icon="DownloadIcon"
                      style="height: 15px;width: 15px;margin-left: 10px;color:#4328AE;cursor:pointer;"
                      @click="downloadPassFront(obusinessDownUrl)" />
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-else>
          <b-row>
            <b-form-group class="col-3" label="Business PAN Number"
              style="font-size:12px;color: #b9b9c3; font-weight: 400;margin-top:10px;">
              <b-form-input type="text" class="form-control" id="task" required="required" name="repayinfo"
                placeholder="Enter PAN No" v-model="panNumber" style="width: 90%;font-size:12px;"
                @input="val => (panNumber = panNumber.toUpperCase())" />
              <label class="control-label" style="
          font-family: 'montserratregular';
          font-size: 12px;
          color: red;
          text-align: center;


        " v-show="errorPan">
                {{ errorPanMsg }}
              </label>
            </b-form-group>

            <b-form-group class="col-3" label="Date of Birth"
              style="font-size:12px;color: #b9b9c3; font-weight: 400;margin-top:10px;">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="CalendarIcon" />
                </b-input-group-prepend>
                <flat-pickr v-model="dob" class="form-control" placeholder="Select DOB" style="font-size:12px;" />
              </b-input-group>
            </b-form-group>

            <b-col md="4" style="padding-top: 7px">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Identity Proof </span><br />

              <div class="row" style="margin-left: 0px;margin-top: 7px;" v-if="currentAddressName.length > 0">
                <!-- <input
      class="form-control"
      id="task"
      required="required"
      name="repayinfo"
      placeholder="Enter pincode"
      v-model="currentpostalcode"


    /> -->
                <input type="file" ref="files" style="display: none" v-on:change="handleFileUploadTwo()" />
                <img src="../../assets/icons/clipIcon.png" style="height: 18px;margin-top: 5px" />

                <b-button @click="$refs.files.click()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-none"
                  style="padding:0px;font-size:11px;margin-left: 10px;">
                  <span v-if="currentAddressName.length > 0" style="font-size:12px;">{{ currentAddressName }}</span>
                  <span style="width: 80%;font-size:12px;" v-else-if="fileNameSet.length > 0">{{ fileNameSet }}</span>
                  <span v-else style="white-space: nowrap;">Upload address proof</span>
                </b-button>

                <b-button @click="uploadDocument()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-dark"
                  style="border-color: #4328AE !important;
color: #4328AE !important;font-size: 11px;height: 30px;">
                  <div class="row" style="margin:auto;">
                    <img src="../../assets/icons/uploadNew.png" style="margin-right:5px" />Upload
                  </div>
                </b-button>
              </div>
              <div class="row" style="margin-left: 0px;margin-top: 7px;" v-else>
                <div style="width:55%;border: 1px solid;
height: 2.714rem;border-radius: 5px;border-color: rgb(185, 185, 195);">
                  <input type="file" ref="files" style="display: none" v-on:change="handleFileUploadOne()" />
                  <!-- <select name="status" id="status" v-model="typeOfBusinessSelected" class="form-control" style="font-size: 12px; color: #5e5873; font-weight: 500;Width:90%;">
<option  v-for="business in buissnessEntityType"  :value="business.value"> {{business.text}} </option>

</select> -->
                  <div class="row" style="width: 100%;margin-left: 10px;margin-top: 8px;" @click="$refs.files.click()">
                    <label style="width: 80%;font-size:12px;" v-if="fileNameSet.length > 0">{{ fileNameSet }}</label>
                    <label style="width: 80%;color: rgb(185, 185, 195);white-space: nowrap;" v-else>Upload Address
                      Proof</label>

                    <img src="../../assets/icons/uploadFileIcon.png"
                      style="height: 15px;margin-top: 1px;margin-left: 5px;" />
                  </div>
                </div>
              </div>
              <label class="control-label" style="
        font-family: 'montserratregular';
        font-size: 12px;
        color: red;
        text-align: center;


      " v-show="uploadAddressFlag">
                {{ uploadAddressMessage }}
              </label>
            </b-col>
          </b-row>
        </div>
      </vx-card>
      <br />

      <vx-card style="padding: 0px;margin-top : 28px">
        <div>
          <div>
            <b-row style="
        border-bottom: 1px solid #ebe9f1;" class="row">
              <span class="col-4 w-full" style="font-size: 18px; color: #5E5873; font-weight: 500;bottom: 10px;">
                Address Proof
              </span>

              <div class="col-8 w-full" style="text-align: right;bottom: 10px;"
                v-if="AddressVerifiedFlag === 'showButton'">
                <b-button @click="EditClickVoter()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-none"
                  style="margin-left: 10px">
                  <feather-icon icon="EditIcon"
                    style="top: 7px;left: 15px;color: #4328AE !important;width:15px;margin-right: 15px;" />
                  Edit
                </b-button>
              </div>

              <div class="col-8 w-full" style="text-align: right;bottom: 10px;"
                v-else-if="AddressVerifiedFlag === 'EditButton'">
                <b-button @click="saveClickVoter()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-primary"
                  style="padding: 5px 5px;
  width: 100px;font-size:11px;">
                  <feather-icon icon="SaveIcon" style="width:16px" class="mr-50" />
                  <span class="align-middle" style="vertical-align: super !important;">Save</span>
                </b-button>
              </div>
            </b-row>
          </div>

          <br />
          <div v-if="
            poaData.length > 0 && ovdAddressType === 'Digio-driving_license'
          ">
            <b-row style="
          border-bottom: 1px solid #ebe9f1;

          padding-bottom: 28px;

        ">
              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioRetrieveNumber != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Licence No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioRetrieveNumber }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Licence No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioRetrieveName">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioRetrieveName }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioRetrieveDob">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioRetrieveDob }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCO }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioStreet }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLocality != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLocality }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCity }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioDistrict != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioDistrict }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioState }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioPin }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLand }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="12" style="padding-top: 10px">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Permanent Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioRetrievePermAdd }}
                </span>
              </b-col>
            </b-row>
          </div>

          <div v-else-if="
            poaData.length > 0 && ovdAddressType === 'Digio-passport'
          ">
            <b-row style="
          border-bottom: 1px solid #ebe9f1;

          padding-bottom: 28px;

        ">
              <b-col md="2" style="padding-top: 10px" v-if="passportRetrieveNumber != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Passport No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ passportRetrieveNumber }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Passport No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="passportRetrieveName != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ passportRetrieveName }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="passportDOB != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ passportDOB }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="passportFatherName != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Father Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ passportFatherName }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Father Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="passportMotherName">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Mother Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ passportMotherName }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Mother Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCO }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioStreet }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLocality != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLocality }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCity }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioDistrict != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioDistrict }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioState }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioPin }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLand }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="12" style="padding-top: 10px" v-if="passportRetrievePermAdd">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Permanent Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ passportRetrievePermAdd }}
                </span>
              </b-col>
              <b-col md="12" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Permanent Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
            </b-row>
          </div>

          <div v-else-if="
            poaData.length > 0 && ovdAddressType === 'Digio-voter_id'
          ">
            <b-row style="
          border-bottom: 1px solid #ebe9f1;

          padding-bottom: 28px;

        ">
              <b-col md="2" style="padding-top: 10px" v-if="voterRetrieveNumber != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  VoterID No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ voterRetrieveNumber }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  VoterID No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="voterRetrieveName != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ voterRetrieveName }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="voterDOB != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ voterDOB }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="voterFatherName != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Father Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ voterFatherName }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Father Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="voterGender">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Gender </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ voterGender }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Gender </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="voterDateOfIssue">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Date Of Issue </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ voterDateOfIssue }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Date Of Issue </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCO }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioStreet }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLocality != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLocality }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCity }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioDistrict != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioDistrict }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioState }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioPin }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLand }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="12" style="padding-top: 10px" v-if="voterRetrievePermAdd">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Permanent Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ voterRetrievePermAdd }}
                </span>
              </b-col>
              <b-col md="12" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Permanent Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
            </b-row>
          </div>

          <div v-else-if="
            poaData.length > 0 && ovdAddressType === 'Physical-aadhar'
          ">
            <b-row style="
          border-bottom: 1px solid #ebe9f1;

          padding-bottom: 28px;

        ">
              <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveNumber != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Aadhaar No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ physicalRetrieveNumber }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Aadhaar No </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveName != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ physicalRetrieveName }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveDOB != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ physicalRetrieveDOB }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  DOB (YYYY-MM-DD) </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="physicalRetrieveGender != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Gender </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ physicalRetrieveGender }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Gender </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCO != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCO }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Care of </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioStreet != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioStreet }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Street Name </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLocality != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLocality }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Locality </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioCity != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioCity }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  City </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioDistrict != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioDistrict }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  District </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioState != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioState }}
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  State </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioPin != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioPin }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Pincode </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-if="drivingDigioLand != ''">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ drivingDigioLand }}
                </span>
              </b-col>
              <b-col md="2" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Landmark </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="6" style="padding-top: 10px;border-right: 1px solid #ebe9f1;" v-if="physicalRetrievePermAdd">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Permanent Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ physicalRetrievePermAdd }}
                </span>
              </b-col>
              <b-col md="6" style="padding-top: 10px;border-right: 1px solid #ebe9f1;" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Permanent Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>

              <b-col md="6" style="padding-top: 10px" v-if="physicalRetrieveCorresAdd">
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Correspondence Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ physicalRetrieveCorresAdd }}
                </span>
              </b-col>
              <b-col md="6" style="padding-top: 10px" v-else>
                <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                  Correspondence Address </span><br />
                <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
                </span>
              </b-col>
            </b-row>
          </div>

          <div v-else>
            <b-row style="align-items: center;">
              <div style="    margin-left: 145px;">
                <img src="../../assets/icons/directorAddressFrame.png" alt="login" class="mx-auto" />
              </div>

              <div class="col-7" style="margin-left: 10px;">
                <span style="font-size: 15px; color: #5e5873; font-weight: 500">
                  No Address Proof available<br />
                  Please upload Address Proof to view details
                </span>
                <br />
                <div class="row" style="padding-left: 14px;margin-top: 20px;">
                  <select name="status" id="status" v-model="typeOfAddressProof" class="form-control"
                    style="font-size: 12px; color: #5e5873; font-weight: 500;width: 200px;color:#4328AE;border-color:#4328AE;">
                    <option value=""> Select Address Proof </option>
                    <option value="POA_DL"> Driving Licence </option>
                    <option value="POA_PASSPORT"> Passport </option>
                    <option value="POA_VOTERID"> Voter ID </option>
                    <option value="POA_AADHAAR"> Aadhaar </option>
                  </select>
                  <b-button @click="createKYCRequest()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                    style="margin-left: 10px">
                    Upload
                  </b-button>
                </div>
                <span id="loanLimitErr" style="color: #a94442;font-size: 12px;" v-show="phoneFlag">
                  {{ phoneFlagMessage }}</span>
                <br />

                <div class="row" style="padding-left: 14px;margin-top: 10px;">
                  <img src="../../assets/icons/lockIcon.png" alt="login" style="width: 15px;
  height: 15px;" />
                  <div style="color:#9E9E9E;font-weight:500;margin-left:8px;margin-right: 8px;font-size: 12px;">
                    You will be redirected to a secured URL to
                    <br />upload Address Proof
                  </div>

                  <div style="color:#9E9E9E;font-weight:500;margin-left:8px;margin-right: 8px;font-size: 12px;">
                    Powered by
                    <br />
                    <img src="../../assets/icons/digioImg.png" alt="login" />
                  </div>
                </div>
                <!-- <b-button
          v-ripple.400="'rgba(30, 30, 30, 0.15)'"
          variant="outline-primary"
          style="margin-left:60px;border: 1px solid #7367F0;white-space: nowrap;width: 170px;margin-top: 10px;"
          @click="ekycClick()"
        >
          eKYC
        </b-button> -->
              </div>
            </b-row>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { BCard } from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import Modal from "@burhanahmeed/vue-modal-2";
import { VueAutosuggest } from "vue-autosuggest";
import flatPickr from "vue-flatpickr-component";
import VuePDFViewer from "vue-instant-pdf-viewer";
import {
  BFormInput,
  BRow,
  BCol,
  BFormGroup,
  BTable,
  BAvatar,
  BBadge,
  BFormSelect,
  BPagination,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BCardBody
} from "bootstrap-vue";
export default {
  data() {
    return {
      header: "",
      allErrorFlag: false,
      allErrorMessage: "",
      alert: false,
      alertMessage: "",
      selectedButton: 0,
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      filterOn: [],
      filterTextArchived: "Clear Filter",
      filterText: "Clear Filter",
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      },
      kycStage: [
        { text: "Select Stage", value: "Select Stage" },
        { text: "COMPLETED", value: "COMPLETED" },
        { text: "STARTED", value: "STARTED" },
        { text: "ADDITIONAL_INFO_REQUIRED", value: "ADDITIONAL_INFO_REQUIRED" }
      ],
      stageSelected: "STARTED",

      fields: [
        {
          key: "invoiceId",
          label: "INVOICE NO"
        },
        {
          key: "createdAt",
          label: "SUBMITTED ON"
        },
        {
          key: "supplierDetails.supplierId",
          label: "SUPPLIER",
          sortable: true
        },
        { key: "borrowerId", label: "MERCHANT", sortable: true },
        { key: "invoiceAmount", label: "AMOUNT", sortable: true }
      ],
      state: {
        disabledDates: {
          from: new Date()
        }
      },
      invoiceNumber: "",
      supplierName: "",
      merchantName: "",
      tabSelected: 1,
      searchText: "",
      selected: [],
      awaitingInvoiceDetails: [],
      closedInvoiceDetails: [],
      activeInvoiceDetails: [],
      submittedInvoiceDetails: [],
      approvedInvoiceDetails: [],
      ignoredInvoiceDetails: [],
      invoiceDetails: [],
      activeTab: 1,
      statusSend: "Submitted",
      invoiceId: "",
      stageName: "",
      nameFlag: false,
      gstFlag: false,
      phoneFlag: false,
      emailFlag: false,
      nameFlagMessage: "",
      gstFlagMessage: "",
      phoneFlagMessage: "",
      emailFlagMessage: "",
      showSupBankFalg: true,
      bankNameFlag: false,
      accErrorFlag: false,
      holderFlag: false,
      ifscCodeFlag: false,
      ifscCodeError: "",
      accTypeFlag: false,
      accTypeError: "",
      accFlagMessage: "",
      holderError: "",
      bankNameError: "",
      accontName: "",
      newBankName: "",
      branchFlag: false,
      branchError: "",
      newBranch: "",

      customerData: [],
      rejecteddLength: 0,
      additionalLength: 0,
      completedLength: 0,
      startedLength: 0,
      notSuccess: false,

      stageName: "",
      startDate: new Date(),
      endDate: new Date(),
      startDateArchived: new Date(),
      endDateArchived: new Date(),
      customerDataWhole: [],
      errorText: "",
      viewCustomerDataFlag: true,
      archivedCustomer: [],
      ArchivedcustomerData: [],
      phoneNumber: "",
      customerName: "",
      CustomerId: "",
      selectedoneArchive: false,
      selectedone: false,
      searchTextArchive: "",
      archivedfilter: "",
      showFilterFlag: false,
      nameDisabled: false,
      panDisabled: false,
      contactDisabled: false,
      generalDisabled: false,
      selectedone: false,
      nameSearch: true,
      panSearch: true,
      contactSearch: true,
      generalSearch: true,
      companyType: "",
      customerId: "",
      borrowerId: "",
      companyName: "",
      authToken: "",
      addsupplierFlag: false,
      confirmDetailsFlag: false,
      confirmFlag: false,
      supplierFlag: false,
      supplierPhoneNo: "",
      supplierGSTNo: "",
      supplierEmailID: "",
      newAccountype: "",
      newBankAccNo: "",
      newIFSCcode: "",
      ifscFlag: false,
      banklist: [],
      filteredOptions: [],
      filteredOptionsIfsc: [],
      ifscDetails: [],
      setbankID: "",
      custType: "",
      kycVerificationIdPrimary: "",
      profileIDs: [],
      profileId: "",
      leadId: "",
      selfieUrl: "",
      businessProofs: [],
      businessProfdata: [],
      docDetailsType: [],
      docGroup: "",
      customerDocnameList: [],
      docType: "",
      docDataNew: [],
      docDataT: [],
      onboardingPartner: "",
      applicationId: "",
      viewProfileID: "",
      programDetails: [],
      supplierIDSet: "",
      financeAddedFlag: false,
      getKycStatus: "",
      setStage: "",
      selectedType: "",
      selectedTypeEntity: "",

      poiData: [],
      businessName: "Not Available",
      businessType: "Not Available",
      businessEntitytype: "",
      contactPersonName: "",
      ContactNo: "",
      EmaiID: "",
      panNo: "",
      panStatus: "",
      panName: "",
      typeOfHolder: "",
      panTitle: "",
      panFirstName: "",
      panMiddleName: "",
      panLastName: "",
      aadharStatus: "",
      lastUpdatedOn: "",
      additionalStatus: "",
      panVerificationChecks: [],
      AddressVerifiedFlag: "showButton",

      secondaryProfileList: [],

      AddressLine1: "",
      careOF: "",
      streetNAme: "",
      loaclity: "",
      city: "",
      district: "",
      State: "",
      pinCode: "",
      landMark: "",
      poaData: [],
      drivingDigioData: [],
      passportData: [],
      voterData: [],
      banklist: [],
      filteredOptions: [],
      filteredOptionsIfsc: [],
      filteredOptionsState: [],
      ifscDetails: [],
      bankaccNo: "",
      bankaccHolderName: "",
      bankNameSet: "",
      ifscCodeSet: "",
      accTypeSet: "",
      micrCodeSet: "",
      pennyDropStatus: "",
      bBankDetails: [],
      verificationData: [],
      ekycPopFlag: false,
      isActive: "Yes",
      deleteStatusFlag: "",
      activeStatusFlag: "",
      isDeleted: "No",
      branchSet: "",
      basicDetAvail: false,
      custName: "",
      errorcustName: false,
      errorcustNameMsg: "",
      custShareHolding: "",
      errorcustShareHolding: false,
      errorcustShareHoldingMsg: "",
      custDIN: "",
      errorcustDIN: false,
      errorcustDINMsg: "",
      custAptDate: "",
      errorcustAptDate: false,
      errorcustAptDateMsg: "",
      custcontactNo: "",
      errorcustcontactNo: false,
      errorcustcontactNoMsg: "",
      custEmailid: "",
      errorcustEmailid: false,
      errorcustEmailidMsg: "",
      viewProfileId: "",
      currentAddressName: "",
      fileNameSet: "",
      panDetails: [],
      dob: new Date(),
      odocumentType: "",
      obusinessDocverified: "",
      DocTypeErrorMsg: "",
      DocTypeError: false,
      uploadFileError: false,
      uploadFileErrorMsg: "",
      udyamData: [],
      showOttheBusiProof: false,
      viewPdfFlag: false,
      busineAllDet: [],
      businessProofFlagOne: false,
      businessDocNameOne: "",
      businessDocSeqOne: "",
      documentTypeOne: "",
      businessDownUrlOne: "",
      busineAllDet: [],
      alert: false,
      alertMessage: "",
      viewPdfFlagOne: false,
      selectedTypeEntity: "",
      otherBusinessAvailable: false,
      showBusinessDetailsAvail: false,
      showPassportFontPop: false,
      viewPassportImage: "",
      typeOfAddressProof: "",
      typeOfAddressProofNew: "",
      errorPan: false,
      errorPanMsg: "",
      uploadAddressFlag: false,
      uploadAddressMessage: "",
      NewDirectorFlag: false,
      showOnceBtn: true,
      secondProfile: false,
      fixedProfileList: [],

      custNameNew: "",
      errorcustNameNew: false,
      errorcustNameMsgNew: "",
      custShareHoldingNew: "",
      errorcustShareHoldingNew: false,
      errorcustShareHoldingMsgNew: "",
      custDINNew: "",
      errorcustDINNew: false,
      errorcustDINMsgNew: "",
      custAptDateNew: "",
      errorcustAptDateNew: false,
      errorcustAptDateMsgNew: "",
      custcontactNoNew: "",
      errorcustcontactNoNew: false,
      errorcustcontactNoMsgNew: "",
      custEmailidNew: "",
      errorcustEmailidNew: false,
      errorcustEmailidMsgNew: "",
      secondaryProfileIdNew: "",
      kycVerifyIDNew: "",
      panNumber: "",
      secondaryProfileSet: ""
    };
  },
  components: {
    Datepicker,
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BRow,
    BCol,
    Modal,
    VueAutosuggest,
    flatPickr,
    "vue-pdf-viewer": VuePDFViewer
  },
  created() {
    this.$store.commit("routeChange", "end");
    this.selectedButton = 0;
    this.borrowerId = this.$route.query.borrowerId;
    this.customerId = this.$route.query.data;
    this.companyName = this.$route.query.companyName;
    this.authToken = this.$route.query.authToken;
    this.loginId = this.$route.query.loginId;
    this.custType = this.$route.query.selectedTypeEntity;
    this.onboardingPartner = this.$route.query.onboardingPartner;
    this.applicationId = this.$route.query.applicationId;
    this.loginType = this.$route.query.loginType;
    this.selectedTypeEntity = this.$route.query.selectedTypeEntity;
    this.dob = this.$moment(this.dob)
      .subtract(18, "Y")
      .format();

    this.customerProfile();

    // this.changeActive(0)
    // this.changeActive(this.selectedButton);
  },
  methods: {
    EditClickVoter() {
      this.editoptionvoter = true;
      this.voterVerifiedFlag = "EditButton";
    },
    createKYCRequestNEW() {
      this.alert = true;
      this.alertMessage = "Please save basic details";
    },
    addNewDirectorClick() {
      this.secondaryProfileList.push(-20);
      this.selectedButton = this.secondaryProfileList.length - 1;
      console.log("thissos is the new selected", this.selectedButton);
      this.NewDirectorFlag = true;
      // this.changeActive(100)
      this.custName = "";
      this.custNameNew = "";
      this.custShareHoldingNew = "";
      this.custDINNew = "";
      this.custAptDateNew = "";
      this.custcontactNoNew = "";
      this.custEmailidNew = "";
      this.custShareHolding = "";
      this.custcontactNo = "";
      this.custEmailid = "";
      this.typeOfAddressProofNew = "";
      this.panNumber = "";
      this.panNo = "";
      this.currentAddressName = "";
      this.fileNameSet = "";
      this.errorPan = false;
      this.showOttheBusiProof = false;
      this.errorcustcontactNo = false;
      this.errorcustEmailid = false;
      this.errorcustAptDate = false;
      this.errorcustName = false;
      this.errorcustShareHolding = false;
      this.errorcustDIN = false;
      this.showOnceBtn = false;
    },
    downloadPassFront(urlSet) {
      var documentUrl = urlSet;
      var docName = this.obusinessDocName;
      let config = {
        // example url
        url: urlSet,
        method: "GET",
        responseType: "blob"
      };
      axios(config).then(response => {
        let routeData = response.config.url;

        axios({
          url: routeData,
          method: "GET",
          responseType: "blob"
        }).then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", docName);
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$store.commit("routeChange", "end");
        });

        //this.src = response.config.url;
      });
    },

    dismissPOPPassportFront() {
      this.showPassportFontPop = false;
    },
    viewPassportFront(url) {
      this.viewPassportImage = url;
      this.showPassportFontPop = true;
    },
    // kycDocuments() {
    //   console.log("this is third tab");
    //   this.busineAllDet = []
    //   this.$store.commit("routeChange", "start");
    //   var timestamp = Math.round(+new Date() / 1000);
    //
    //   var data = {
    //     customerID: this.customerId,
    //   };
    //   var msgHeader = {
    //     authToken: localStorage.getItem("authtoken"), //dynamic
    //     authLoginID: this.$store.getters.loginId,
    //     timestamp: timestamp,
    //     ipAddress: "",
    //   };
    //   var employeeKycDetails = { data, msgHeader };
    //   axios
    //     .post("mlCustomerDetails", employeeKycDetails)
    //     .then((response) => {
    //       const JSONData = response.data;
    //       if (JSONData.data.error == 0) {
    //         this.dataAvailable = true;
    //         // this.getKycVerificationID();
    //
    //         // this.companyName = JSONData.data.custDetails.companyName;
    //         // this.partnerName = JSONData.data.custDetails.onboardingPartner;
    //          this.custKycDocuments = JSONData.data.custKycDocuments;
    //         // this.mobileNumber = JSONData.data.custCredentials.loginID;
    //         // this.customerProfile();
    //         this.custKycBusi = JSONData.data.custKycDocuments.reverse();
    //         for (var i = 0; i < this.custKycDocuments.length; i++) {
    //           if (
    //             this.custKycBusi[i].documentTypeID === 110 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 139 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 147 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             // this.custKycBusi[i].documentTypeID === 148 &&
    //             // this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 149 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 150 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 151 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 152 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 161 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 172 &&
    //             this.custKycBusi[i].verificationStatus != "N" ||
    //             this.custKycBusi[i].documentTypeID === 177 &&
    //             this.custKycBusi[i].verificationStatus != "N"
    //           ) {
    //             this.busineAllDet.push(this.custKycBusi[i])
    //             console.log("this is thw doc which are loaede",JSON.stringify(this.custKycBusi[i]))
    //             if(this.busineAllDet.length === 1)
    //             {
    //             this.businessProofFlag = true
    //             this.pobDataVailable = true
    //             this.businessDocName = this.busineAllDet[0].documentUrl;
    //             this.businessDocSeq = this.busineAllDet[0].docSeqID;
    //             this.documentType = this.busineAllDet[0].documentType
    //             this.businessDocverified = this.busineAllDet[0].verificationStatus;
    //             this.businessDownUrl = "https://uatgateway.supermoney.in/python/" + "mlS3Read?customerID=" + this.customerId + "&docSeqID=" + this.busineAllDet[0].docSeqID;
    //             if(this.businessDocName.includes(".pdf"))
    //             {
    //               this.viewPdfFlag = true
    //             }
    //             else
    //             {
    //               this.viewPdfFlag = false
    //             }
    //           }
    //           else
    //           {
    //             this.businessProofFlag = true
    //             this.pobDataVailable = true
    //             this.businessDocName = this.busineAllDet[0].documentUrl;
    //             this.businessDocSeq = this.busineAllDet[0].docSeqID;
    //             this.documentType = this.busineAllDet[0].documentType
    //             this.businessDocverified = this.busineAllDet[0].verificationStatus;
    //             this.businessDownUrl = "https://uatgateway.supermoney.in/python/" + "mlS3Read?customerID=" + this.customerId + "&docSeqID=" + this.busineAllDet[0].docSeqID;
    //             if(this.businessDocName.includes(".pdf"))
    //             {
    //               this.viewPdfFlag = true
    //             }
    //             else
    //             {
    //               this.viewPdfFlag = false
    //             }
    //
    //
    //             this.businessProofFlagOne = true
    //
    //             this.businessDocNameOne = this.busineAllDet[1].documentUrl;
    //             this.businessDocSeqOne = this.busineAllDet[1].docSeqID;
    //             this.documentTypeOne = this.busineAllDet[1].documentType
    //             this.businessDocverifiedOne = this.busineAllDet[1].verificationStatus;
    //             this.businessDownUrlOne = "https://uatgateway.supermoney.in/python/" + "mlS3Read?customerID=" + this.customerId + "&docSeqID=" + this.busineAllDet[1].docSeqID;
    //             if(this.businessDocNameOne.includes(".pdf"))
    //             {
    //               this.viewPdfFlagOne = true
    //             }
    //             else
    //             {
    //               this.viewPdfFlagOne = false
    //             }
    //           }
    //
    //           }
    //
    //
    //           if (
    //             this.custKycBusi[i].documentTypeID === 100 &&
    //             this.custKycBusi[i].verificationStatus != "N" &&
    //             this.custKycBusi[i].profileID === this.viewProfileId)
    //             {
    //               this.showOtherbusinessProofFlag = true
    //               this.obusinessDocName = this.custKycBusi[i].documentUrl;
    //               this.obusinessDocSeq = this.custKycBusi[i].docSeqID;
    //               this.odocumentType = this.custKycBusi[i].documentType
    //               this.obusinessDocverified = this.custKycBusi[i].verificationStatus;
    //               this.obusinessDownUrl = "https://uatgateway.supermoney.in/python/" + "mlS3Read?customerID=" + this.customerId + "&docSeqID=" + this.custKycDocuments[i].docSeqID;
    //               if(this.obusinessDocName.includes(".pdf"))
    //               {
    //                 this.viewPdfFlag = true
    //                 console.log("this is true for all pdf",this.viewPdfFlag)
    //               }
    //               else
    //               {
    //                 this.viewPdfFlag = false
    //               }
    //               this.showOttheBusiProof = true
    //             }
    //         }
    //
    //
    //
    //
    //
    //
    //
    //
    //         this.$store.commit("routeChange", "end");
    //       } else {
    //         this.errorMessage = JSONData.data.message;
    //         this.GeneralError = true;
    //         this.dataAvailable = false;
    //       }
    //       this.$store.commit("routeChange", "end");
    //     })
    //     .catch((error) => {
    //       this.errorText = error;
    //       this.dataAvailable = false;
    //       console.log("display Error" + this.errorText);
    //       this.$store.commit("routeChange", "end");
    //     });
    // },

    async kycDocuments() {
      var self = this;
      self.docDataNew = [];
      self.customerDocnameList = [];
      self.docData = [];

      var url =
        "https://uatgateway.supermoney.in/crmbackend/CustomerKycDocument/?customer_id=" +
        self.customerId;

      axios
        .get(url)
        .then(async function (response) {
          // handle success
          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            self.dataAvailable = true;
            self.customerDocnameList = JSONData.data.DocumentGroupList;

            for (var i = 0; i < self.customerDocnameList.length; i++) {
              var key = self.customerDocnameList[i];

              if (JSONData.data.DocumentGroupData[key].length > 0) {
                self.docDataNew.push(JSONData.data.DocumentGroupData[key]);
              }

              self.docDataT = [].concat.apply([], self.docDataNew);
            }

            for (var i = 0; i < self.docDataT.length; i++) {
              if (self.docDataT[i].verification_status != "N") {
                self.docData.push(self.docDataT[i]);
              }
            }

            for (var i = 0; i < self.docData.length; i++) {
              // let s3Url = await self.getUrlS3Docs(self.docData[i].document_url);

              if (
                self.docData[i].document_type_id === 110 ||
                self.docData[i].document_type_id === 139 ||
                self.docData[i].document_type_id === 147 ||
                self.docData[i].document_type_id === 139 ||
                self.docData[i].document_type_id === 150 ||
                self.docData[i].document_type_id === 151 ||
                self.docData[i].document_type_id === 152 ||
                self.docData[i].document_type_id === 161 ||
                self.docData[i].document_type_id === 172 ||
                self.docData[i].document_type_id === 177
              ) {
                console.log("thuhss v", self.docData[i]);

                // this.busineAllDet.push(this.custKycBusi[i])
                self.busineAllDet.push(self.docData[i]);

                if (self.busineAllDet.length === 1) {
                  let s3Url = await self.getUrlS3Docs(
                    self.busineAllDet[0].document_url
                  );

                  console.log(
                    "this is true povdsv",
                    self.busineAllDet[0].document_url
                  );
                  self.businessProofFlag = true;
                  self.pobDataVailable = true;

                  self.businessDocName = self.busineAllDet[0].document_url;
                  self.businessDocSeq = self.busineAllDet[0].doc_seq_id;
                  self.documentType = self.busineAllDet[0].document_type;
                  self.businessDocverified =
                    self.busineAllDet[0].verification_status;
                  self.businessDownUrl = s3Url;
                  if (self.busineAllDet[0].document_url.includes(".pdf")) {
                    self.viewPdfFlag = true;
                  } else {
                    self.viewPdfFlag = false;
                  }
                } else {
                  let s3Url = await self.getUrlS3Docs(
                    this.busineAllDet[i].document_url
                  );
                  self.businessProofFlag = true;
                  self.pobDataVailable = true;

                  self.businessDocName = this.busineAllDet[0].document_url;
                  self.businessDocSeq = this.busineAllDet[0].doc_seq_id;
                  self.documentType = this.busineAllDet[0].document_type;
                  self.businessDocverified = this.busineAllDet[0].verification_status;
                  self.businessDownUrl = s3Url;
                  if (self.businessDocName.includes(".pdf")) {
                    self.viewPdfFlag = true;
                  } else {
                    self.viewPdfFlag = false;
                  }

                  self.businessProofFlagOne = true;

                  self.businessDocNameOne = self.busineAllDet[1].document_url;
                  self.businessDocSeqOne = self.busineAllDet[1].doc_seq_id;
                  self.documentTypeOne = self.busineAllDet[1].document_type;
                  self.businessDocverifiedOne =
                    self.busineAllDet[1].verification_status;
                  self.businessDownUrlOne = s3Url;
                  if (self.businessDocNameOne.includes(".pdf")) {
                    self.viewPdfFlagOne = true;
                  } else {
                    self.viewPdfFlagOne = false;
                  }
                }
              }

              if (
                self.docData[i].documentTypeID === 148 &&
                self.docData[i].verificationStatus != "N"
              ) {
                let s3Url = await self.getUrlS3Docs(
                  self.docData[i].document_url
                );
                self.showOtherbusinessProofFlag = true;
                self.obusinessDocName = self.custKycBusi[i].document_url;
                self.obusinessDocSeq = self.custKycBusi[i].doc_seq_id;
                self.odocumentType = self.custKycBusi[i].document_type;
                self.obusinessDocverified =
                  self.custKycBusi[i].verification_status;
                self.obusinessDownUrl = s3Url;
                if (self.obusinessDocName.includes(".pdf")) {
                  self.viewPdfFlag = true;
                } else {
                  self.viewPdfFlag = false;
                }
                self.showOttheBusiProof = true;
              }
            }

            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
        });
    },

    getUrlS3Docs(url) {
      let self = this;

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mlservice/AWS/",
        headers: { "content-type": "application/json" }
      });

      let data = {
        get: [
          {
            url: url,
            as_base46: false,
            as_presigned_url: true
          }
        ]
      };

      return instance
        .post("S3/", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.error === "") {
            return JSONData.collect[0].signed_url;
          } else {
            self.alert = true;
            self.alertMessage = JSONData.kaleyraError;
            return null;
          }
        })
        .catch(error => {
          console.log("display  ==" + error);
          return null;
        })
        .finally(() => {
          self.$store.commit("routeChange", "end");
        });
    },

    createKYCRequest() {
      if (this.typeOfAddressProof != "") {
        this.$store.commit("routeChange", "start");
        let self = this;
        // let url = "/mintLoan/mintloan/digioKYCDetails";
        const instance = axios.create({
          baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",

          headers: { "content-type": "application/json" }
        });
        let msgHeader = {
          authToken: "", //dynamic
          loginId: self.loginId,
          channelType: "M",
          consumerId: "414",
          deviceId: "onboarding",
          source: "webDirect"
        };
        let deviceFPmsgHeader = {
          clientIPAddress: "192.168.0.122",
          connectionMode: "WIFI",
          country: "United States",
          deviceManufacturer: "Xiaomi",
          deviceModelNo: "Mi A2",
          dualSim: false,
          imeiNo: "09d9212a07553637",
          latitude: "",
          longitude: "",
          nwProvider: "xxxxxxxx",
          osName: "Android",
          osVersion: 28,
          timezone: "Asia/Kolkata",
          versionCode: "58",
          versionName: "5.5.1"
        };
        let data = {
          profileId: self.viewProfileId,
          applicationId: self.applicationId,
          apiType: "digioCreateKYCRequest",
          request: {
            customer_identifier: self.loginId.substring(3),
            template_name: self.typeOfAddressProof,
            notify_customer: false,
            generate_access_token: true
          }
        };
        let finalObject = { data, deviceFPmsgHeader, msgHeader };
        console.log(JSON.stringify(finalObject));
        instance
          .post("digioKYCDetails", finalObject)
          .then(function (response) {
            const JSONData = response.data;
            self.authToken = JSONData.header.authToken;

            console.log("Hit API 1");
            if (JSONData.data.successFlag) {
              console.log("Hit API 2");
              self.openPOADigio(
                JSONData.data.details.id,
                JSONData.data.details.customer_identifier,
                JSONData.data.details.access_token.id
              );
            }
          })
          .catch(function (error) {
            // handle error
            console.log("display  ==" + error);
          })
          .finally(function () {
            self.$store.commit("routeChange", "end");
          });
      } else {
        this.phoneFlag = true;
        this.phoneFlagMessage = "Please select address proof type";
      }
    },

    openPOADigio(KID, identifier, accessToken) {
      console.log("Hit API");
      let self = this;
      let options = {
        environment: "production",
        callback: function (response) {
          if (response.hasOwnProperty("error_code")) {
            return console.log("error occurred in process");
          }

          self.completePOAKYCRequest(response.digio_doc_id);
        },
        logo: "https://www.supermoney.in/supermoneylogo.png",
        theme: {
          primaryColor: "#AB3498",
          secondaryColor: "#000000"
        }
      };

      console.log("this is KID", KID);
      console.log("this is identifier", identifier);
      console.log("this is accessToken", accessToken);

      let digio = new Digio(options); //options is the digio options constructor object.
      digio.init();
      digio.submit(KID, identifier, accessToken);
    },

    completePOAKYCRequest(kycID) {
      let address = "";
      this.$store.commit("routeChange", "start");
      let self = this;
      // let url = "/mintLoan/mintloan/digioKYCDetails";
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",

        headers: { "content-type": "application/json" }
      });
      let msgHeader = {
        authToken: "", //dynamic
        loginId: self.loginId,
        channelType: "M",
        consumerId: "414",
        deviceId: "onboarding",
        source: "webDirect"
      };
      let deviceFPmsgHeader = {
        clientIPAddress: "192.168.0.122",
        connectionMode: "WIFI",
        country: "United States",
        deviceManufacturer: "Xiaomi",
        deviceModelNo: "Mi A2",
        dualSim: false,
        imeiNo: "09d9212a07553637",
        latitude: "",
        longitude: "",
        nwProvider: "xxxxxxxx",
        osName: "Android",
        osVersion: 28,
        timezone: "Asia/Kolkata",
        versionCode: "58",
        versionName: "5.5.1"
      };
      let data = {
        profileId: self.viewProfileId,
        applicationId: self.applicationId,
        apiType: "digioGetKYCPOAdetails",
        request: {
          request_id: kycID
        }
      };
      let finalObject = { data, deviceFPmsgHeader, msgHeader };
      console.log(JSON.stringify(finalObject));
      instance
        .post("digioKYCDetails", finalObject)
        .then(function (response) {
          const JSONData = response.data;
          self.authToken = JSONData.header.authToken;

          if (JSONData.data.successFlag) {
            let dataToSend = {
              customer_id: self.customerId,
              profile_id: self.viewProfileId,
              kyc_verification_id: self.kycVerificationIdPrimary,
              data: []
            };

            if (
              self.typeOfAddressProof == "POA_VOTERID" &&
              JSONData.data.details.actions[0].hasOwnProperty("file_id")
            ) {
              let voterID = {
                source: "Digio-voter_id",
                data: {
                  id_no: JSONData.data.details.actions[0].ocr_result.id_no,
                  gender: JSONData.data.details.actions[0].ocr_result.gender,
                  name: JSONData.data.details.actions[0].ocr_result.name,
                  fathers_name:
                    JSONData.data.details.actions[0].ocr_result.fathers_name,
                  dob: self
                    .$moment(
                      JSONData.data.details.actions[0].ocr_result.dob,
                      "DD/MM/YYYY"
                    )
                    .format("yyyy-MM-DD"),
                  address: JSONData.data.details.actions[0].ocr_result.address,
                  date_of_issue:
                    JSONData.data.details.actions[0].ocr_result.date_of_issue
                }
              };
              address = JSONData.data.details.actions[0].ocr_result.address;
              dataToSend.data.push(voterID);
            }
            if (
              self.typeOfAddressProof == "POA_PASSPORT" &&
              JSONData.data.details.actions[0].hasOwnProperty("file_id")
            ) {
              let passport = {
                source: "Digio-passport",
                data: {
                  id_no: JSONData.data.details.actions[0].ocr_result.id_no,
                  mothers_name:
                    JSONData.data.details.actions[0].ocr_result.mothers_name,
                  name: JSONData.data.details.actions[0].ocr_result.name,
                  fathers_name:
                    JSONData.data.details.actions[0].ocr_result.fathers_name,
                  dob: self
                    .$moment(
                      JSONData.data.details.actions[0].ocr_result.dob,
                      "DD/MM/YYYY"
                    )
                    .format("yyyy-MM-DD"),
                  address: JSONData.data.details.actions[0].ocr_result.address
                }
              };
              address = JSONData.data.details.actions[0].ocr_result.address;
              dataToSend.data.push(passport);
            }
            if (
              self.typeOfAddressProof == "POA_DL" &&
              JSONData.data.details.actions[0].hasOwnProperty("file_id")
            ) {
              let driving_license = {
                source: "Digio-driving_license",
                data: {
                  id_no: JSONData.data.details.actions[0].ocr_result.id_no,
                  name: JSONData.data.details.actions[0].ocr_result.name,
                  dob: self
                    .$moment(
                      JSONData.data.details.actions[0].ocr_result.dob,
                      "DD-MM-YYYY"
                    )
                    .format("yyyy-MM-DD"),
                  address: JSONData.data.details.actions[0].ocr_result.address
                }
              };
              address = JSONData.data.details.actions[0].ocr_result.address;
              dataToSend.data.push(driving_license);
            }

            if (
              self.typeOfAddressProof == "POA_AADHAAR" &&
              JSONData.data.details.actions[0].hasOwnProperty("file_id")
            ) {
              let voterID = {
                data: {
                  id_number: JSONData.data.details.actions[0].ocr_result.id_no,
                  name: JSONData.data.details.actions[0].ocr_result.name,
                  dob: JSONData.data.details.actions[0].ocr_result.dob,
                  gender: JSONData.data.details.actions[0].ocr_result.gender,
                  permanent_address:
                    JSONData.data.details.actions[0].ocr_result.address,
                  current_address:
                    JSONData.data.details.actions[0].ocr_result.address
                },
                source: "Physical-aadhar"
              };
              address = JSONData.data.details.actions[0].ocr_result.address;
              dataToSend.data.push(voterID);
            }

            if (dataToSend.data.length > 0) {
              self.callSplitAddress(dataToSend, address);
            } else {
              this.alertMessage = "Information not recieved try again";
              this.alert = true;
            }
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");
        });
    },

    callSplitAddress(dataSend, address) {
      this.$store.commit("routeChange", "start");
      let self = this;
      // let url = "https://uatgateway.supermoney.in/karzaservices/karza/addressSplit";
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/karzaservices/karza/",

        headers: { "content-type": "application/json" }
      });
      let data = {
        address: address
      };
      instance
        .post("addressSplit", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          let co = "C/O";
          dataSend.data[0].data["C/O"] = JSONData.response[co];
          dataSend.data[0].data.House = JSONData.response.House;
          dataSend.data[0].data.Floor = JSONData.response.Floor;
          dataSend.data[0].data.Building = JSONData.response.Building;
          dataSend.data[0].data.Complex = JSONData.response.Complex;
          dataSend.data[0].data.Street = JSONData.response.Street;
          dataSend.data[0].data.Untagged = JSONData.response.Untagged;
          dataSend.data[0].data.locality = JSONData.response.locality;
          dataSend.data[0].data.State = JSONData.response.State;
          dataSend.data[0].data.District = JSONData.response.District;
          dataSend.data[0].data.City = JSONData.response.City;
          dataSend.data[0].data.Landmark = JSONData.response.Landmark;
          dataSend.data[0].data.Pin = JSONData.response.Pin;

          self.uploadDataToKYC(dataSend);
        })
        .catch(function (error) {
          // handle error
          self.uploadDataToKYC(dataSend);
          console.log("display  ==" + error);
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");
        });
    },
    uploadDataToKYC(dataSend) {
      this.$store.commit("routeChange", "start");
      let self = this;
      // let url = "/mintLoan/mintloan/kycCustomerServices";
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",

        headers: { "content-type": "application/json" }
      });
      let data = {
        kycServicesType: "CustomerKycDetails",
        request: dataSend
      };
      let timestamp = Math.round(+new Date() / 1000);
      let msgHeader = {
        authToken: "", //dynamic
        loginId: self.loginId,
        channelType: "M",
        consumerId: "414",
        deviceId: "MerchantWebApp",
        source: "webDirect"
      };
      let deviceFPmsgHeader = {
        clientIPAddress: "192.168.0.122",
        connectionMode: "WIFI",
        country: "United States",
        deviceManufacturer: "Xiaomi",
        deviceModelNo: "Mi A2",
        dualSim: false,
        imeiNo: "09d9212a07553637",
        latitude: "",
        longitude: "",
        nwProvider: "xxxxxxxx",
        osName: "Android",
        osVersion: 28,
        timezone: "Asia/Kolkata",
        versionCode: "58",
        versionName: "5.5.1"
      };
      let createWorkflowRequest = { data, deviceFPmsgHeader, msgHeader };
      instance
        .post("kycCustomerServices", createWorkflowRequest)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.data.successFlag) {
            self.getKycVerificationID();
          } else {
            self.alertMessage = JSONData.payload.errorResponse.errorMessage;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");
        });
    },

    getPOAData() {
      this.$store.commit("routeChange", "start");
      var self = this;

      // var url = 'https://uatgateway.supermoney.in/kycServices/CustomerKycDetails/?kyc_verification_id='+self.profile.kycIds[0].kyc_verification_id+'&customer_id='+self.$route.query.data+'&source_type=POA';
      var url =
        "https://uatgateway.supermoney.in/kycServices/CustomerKycDetails/?kyc_verification_id=" +
        self.kycVerificationIdPrimary +
        "&customer_id=" +
        self.customerId +
        "&source_type=POA";
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            self.poaData = JSONData.data;
            self.drivingDigioData = self.poaData.filter(
              item => item.source == "Digio-driving_license"
            );

            if (self.drivingDigioData.length > 0) {
              self.poaDataAvailable = "Edit";
              self.ovdAddressType = "Digio-driving_license";
              for (var i = 0; i < self.drivingDigioData.length; i++) {
                if (self.drivingDigioData[i].key_name === "license_number") {
                  self.drivingDigioRetrieveNumber =
                    self.drivingDigioData[i].value;
                  self.drivingDigioRetrieveNumberAuto =
                    self.drivingDigioData[i].auto_id;
                }
                if (self.drivingDigioData[i].key_name === "license_name") {
                  self.drivingDigioRetrieveName =
                    self.drivingDigioData[i].value;
                  self.drivingDigioRetrieveNameAuto =
                    self.drivingDigioData[i].auto_id;
                }

                if (self.drivingDigioData[i].key_name === "license_dob") {
                  self.drivingDigioRetrieveDob = self.drivingDigioData[i].value;
                  self.drivingDigioRetrieveDobAuto =
                    self.drivingDigioData[i].auto_id;
                }

                if (self.drivingDigioData[i].key_name === "license_address") {
                  self.drivingDigioRetrievePermAdd =
                    self.drivingDigioData[i].value;
                  self.drivingDigioRetrievePermAddAuto =
                    self.drivingDigioData[i].auto_id;
                }
                if (self.drivingDigioData[i].key_name === "c/o") {
                  self.drivingDigioCO = self.drivingDigioData[i].value;
                  self.drivingDigioCOAuto = self.drivingDigioData[i].auto_id;
                }
                if (self.drivingDigioData[i].key_name === "street") {
                  self.drivingDigioStreet = self.drivingDigioData[i].value;
                  self.drivingDigioStreetAuto =
                    self.drivingDigioData[i].auto_id;
                }

                if (self.drivingDigioData[i].key_name === "locality") {
                  self.drivingDigioLocality = self.drivingDigioData[i].value;
                  self.drivingDigioLocalityAuto =
                    self.drivingDigioData[i].auto_id;
                }

                if (self.drivingDigioData[i].key_name === "city") {
                  self.drivingDigioCity = self.drivingDigioData[i].value;
                  self.drivingDigioCityAuto = self.drivingDigioData[i].auto_id;
                }
                if (self.drivingDigioData[i].key_name === "district") {
                  self.drivingDigioDistrict = self.drivingDigioData[i].value;
                  self.drivingDigioDistrictAuto =
                    self.drivingDigioData[i].auto_id;
                }
                if (self.drivingDigioData[i].key_name === "state") {
                  self.drivingDigioState = self.drivingDigioData[i].value;
                  self.drivingDigioStateAuto = self.drivingDigioData[i].auto_id;
                }
                if (self.drivingDigioData[i].key_name === "pin") {
                  self.drivingDigioPin = self.drivingDigioData[i].value;
                  self.drivingDigioPinAuto = self.drivingDigioData[i].auto_id;
                }
                if (self.drivingDigioData[i].key_name === "landmark") {
                  self.drivingDigioLand = self.drivingDigioData[i].value;
                  self.drivingDigioLandAuto = self.drivingDigioData[i].auto_id;
                }
              }
            } else {
              self.drivingDigioVerifiedFlag = "None";
            }

            self.passportData = self.poaData.filter(
              item => item.source == "Digio-passport"
            );

            if (self.passportData.length > 0) {
              self.poaDataAvailable = "Edit";
              self.ovdAddressType = "Digio-passport";
              for (var i = 0; i < self.passportData.length; i++) {
                if (self.passportData[i].key_name === "passport_number") {
                  self.passportRetrieveNumber = self.passportData[i].value;
                  self.passportRetrieveNumberAuto =
                    self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "passport_name") {
                  self.passportRetrieveName = self.passportData[i].value;
                  self.passportRetrieveNameAuto = self.passportData[i].auto_id;
                }

                if (self.passportData[i].key_name === "passport_address") {
                  self.passportRetrievePermAdd = self.passportData[i].value;
                  self.passportRetrievePermAddAuto =
                    self.passportData[i].auto_id;
                }

                if (self.passportData[i].key_name === "passport_father_name") {
                  self.passportFatherName = self.passportData[i].value;
                  self.passportFatherNameAuto = self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "passport_mother_name") {
                  self.passportMotherName = self.passportData[i].value;
                  self.passportMotherNameAuto = self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "passport_dob") {
                  self.passportDOB = self.passportData[i].value;

                  self.passportDOBAuto = self.passportData[i].auto_id;
                }

                if (self.passportData[i].key_name === "c/o") {
                  self.drivingDigioCO = self.passportData[i].value;
                  self.drivingDigioCOAuto = self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "street") {
                  self.drivingDigioStreet = self.passportData[i].value;
                  self.drivingDigioStreetAuto = self.passportData[i].auto_id;
                }

                if (self.passportData[i].key_name === "locality") {
                  self.drivingDigioLocality = self.passportData[i].value;
                  self.drivingDigioLocalityAuto = self.passportData[i].auto_id;
                }

                if (self.passportData[i].key_name === "city") {
                  self.drivingDigioCity = self.passportData[i].value;
                  self.drivingDigioCityAuto = self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "district") {
                  self.drivingDigioDistrict = self.passportData[i].value;
                  self.drivingDigioDistrictAuto = self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "state") {
                  self.drivingDigioState = self.passportData[i].value;

                  self.drivingDigioStateAuto = self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "pin") {
                  self.drivingDigioPin = self.passportData[i].value;

                  self.drivingDigioPinAuto = self.passportData[i].auto_id;
                }
                if (self.passportData[i].key_name === "landmark") {
                  self.drivingDigioLand = self.passportData[i].value;

                  self.drivingDigioLandAuto = self.passportData[i].auto_id;
                }
              }
            } else {
              self.passportVerifiedFlag = "None";
            }

            self.voterData = self.poaData.filter(
              item => item.source == "Digio-voter_id"
            );

            if (self.voterData.length > 0) {
              self.poaDataAvailable = "Edit";
              self.ovdAddressType = "Digio-voter_id";
              for (var i = 0; i < self.voterData.length; i++) {
                if (self.voterData[i].key_name === "voterid_number") {
                  self.voterRetrieveNumber = self.voterData[i].value;
                  self.voterRetrieveNumberAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "voterid_name") {
                  self.voterRetrieveName = self.voterData[i].value;
                  self.voterRetrieveNameAuto = self.voterData[i].auto_id;
                }

                if (self.voterData[i].key_name === "voterid_address") {
                  self.voterRetrievePermAdd = self.voterData[i].value;
                  self.voterRetrievePermAddAuto = self.voterData[i].auto_id;
                }

                if (self.voterData[i].key_name === "voterid_father_name") {
                  self.voterFatherName = self.voterData[i].value;
                  self.voterFatherNameAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "voterid_date_of_issue") {
                  (self.voterDateOfIssue = self
                    .$moment(self.voterData[i].value)
                    .format("YYYY-MM-DD")),
                    (self.voterDateOfIssueAuto = self.voterData[i].auto_id);
                }
                if (self.voterData[i].key_name === "voterid_dob") {
                  self.voterDOB = self.voterData[i].value;
                  self.voterDOBAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "voterid_gender") {
                  self.voterGender = self.voterData[i].value;
                  self.voterGenderAuto = self.voterData[i].auto_id;
                }

                if (self.voterData[i].key_name === "c/o") {
                  self.drivingDigioCO = self.voterData[i].value;
                  self.drivingDigioCOAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "street") {
                  self.drivingDigioStreet = self.voterData[i].value;
                  self.drivingDigioStreetAuto = self.voterData[i].auto_id;
                }

                if (self.voterData[i].key_name === "locality") {
                  self.drivingDigioLocality = self.voterData[i].value;
                  self.drivingDigioLocalityAuto = self.voterData[i].auto_id;
                }

                if (self.voterData[i].key_name === "city") {
                  self.drivingDigioCity = self.voterData[i].value;
                  self.drivingDigioCityAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "district") {
                  self.drivingDigioDistrict = self.voterData[i].value;
                  self.drivingDigioDistrictAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "state") {
                  self.drivingDigioState = self.voterData[i].value;
                  self.drivingDigioStateAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "pin") {
                  self.drivingDigioPin = self.voterData[i].value;
                  self.drivingDigioPinAuto = self.voterData[i].auto_id;
                }
                if (self.voterData[i].key_name === "landmark") {
                  self.drivingDigioLand = self.voterData[i].value;
                  self.drivingDigioLandAuto = self.voterData[i].auto_id;
                }
              }
            } else {
              self.voterVerifiedFlag = "None";
            }

            self.digiLocAadhaar = self.poaData.filter(
              item => item.source == "Digilocker-aadhaar"
            );

            if (self.digiLocAadhaar.length > 0) {
              self.poaDataAvailable = "Edit";
              self.ovdAddressType = "Digilocker-aadhaar";
              for (var i = 0; i < self.digiLocAadhaar.length; i++) {
                if (self.digiLocAadhaar[i].key_name === "c/o") {
                  self.drivingDigioCO = self.digiLocAadhaar[i].value;
                  self.drivingDigioCOAuto = self.digiLocAadhaar[i].auto_id;
                }
                if (self.digiLocAadhaar[i].key_name === "street") {
                  self.drivingDigioStreet = self.digiLocAadhaar[i].value;
                  self.drivingDigioStreetAuto = self.digiLocAadhaar[i].auto_id;
                }

                if (self.digiLocAadhaar[i].key_name === "locality") {
                  self.drivingDigioLocality = self.digiLocAadhaar[i].value;
                  self.drivingDigioLocalityAuto =
                    self.digiLocAadhaar[i].auto_id;
                }

                if (self.digiLocAadhaar[i].key_name === "city") {
                  self.drivingDigioCity = self.digiLocAadhaar[i].value;
                  self.drivingDigioCityAuto = self.digiLocAadhaar[i].auto_id;
                }
                if (self.digiLocAadhaar[i].key_name === "district") {
                  self.drivingDigioDistrict = self.digiLocAadhaar[i].value;
                  self.drivingDigioDistrictAuto =
                    self.digiLocAadhaar[i].auto_id;
                }
                if (self.digiLocAadhaar[i].key_name === "state") {
                  self.drivingDigioState = self.digiLocAadhaar[i].value;
                  self.drivingDigioStateAuto = self.digiLocAadhaar[i].auto_id;
                }
                if (self.digiLocAadhaar[i].key_name === "pin") {
                  self.drivingDigioPin = self.digiLocAadhaar[i].value;
                  self.drivingDigioPinAuto = self.digiLocAadhaar[i].auto_id;
                }
                if (self.digiLocAadhaar[i].key_name === "landmark") {
                  self.drivingDigioLand = self.digiLocAadhaar[i].value;
                  self.drivingDigioLandAuto = self.digiLocAadhaar[i].auto_id;
                }
              }
            } else {
              self.voterVerifiedFlag = "None";
            }

            self.physicalData = self.poaData.filter(
              item => item.source == "Physical-aadhar"
            );
            console.log(
              "this is the physical data",
              JSON.stringify(self.physicalData)
            );

            if (self.physicalData.length > 0) {
              self.poaDataAvailable = "Edit";
              self.ovdAddressType = "Physical-aadhar";

              for (var i = 0; i < self.physicalData.length; i++) {
                if (self.physicalData[i].key_name === "aadhaar_number") {
                  self.physicalRetrieveNumber = self.physicalData[i].value;
                  self.physicalRetrieveNumberAuto =
                    self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "aadhaar_name") {
                  console.log("this is the name", self.physicalRetrieveName);
                  self.physicalRetrieveName = self.physicalData[i].value;
                  self.physicalRetrieveNameAuto = self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "aadhaar_dob") {
                  self.physicalRetrieveDOB = self.physicalData[i].value;
                  self.physicalRetrieveDOBAuto = self.physicalData[i].auto_id;
                }

                if (self.physicalData[i].key_name === "aadhaar_gender") {
                  self.physicalRetrieveGender = self.physicalData[i].value;
                  self.physicalRetrieveGenderAuto =
                    self.physicalData[i].auto_id;
                }

                if (self.physicalData[i].key_name === "aadhaar_permfulladd") {
                  self.physicalRetrievePermAdd = self.physicalData[i].value;
                  self.physicalRetrievePermAddAuto =
                    self.physicalData[i].auto_id;
                }

                if (self.physicalData[i].key_name === "aadhaar_currfulladd") {
                  self.physicalRetrieveCorresAdd = self.physicalData[i].value;
                  self.physicalRetrieveCorresAddAuto =
                    self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "c/o") {
                  self.drivingDigioCO = self.physicalData[i].value;
                  self.drivingDigioCOAuto = self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "street") {
                  self.drivingDigioStreet = self.physicalData[i].value;
                  self.drivingDigioStreetAuto = self.physicalData[i].auto_id;
                }

                if (self.physicalData[i].key_name === "locality") {
                  self.drivingDigioLocality = self.physicalData[i].value;
                  self.drivingDigioLocalityAuto = self.physicalData[i].auto_id;
                }

                if (self.physicalData[i].key_name === "city") {
                  self.drivingDigioCity = self.physicalData[i].value;
                  self.drivingDigioCityAuto = self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "district") {
                  self.drivingDigioDistrict = self.physicalData[i].value;
                  self.drivingDigioDistrictAuto = self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "state") {
                  self.drivingDigioState = self.physicalData[i].value;
                  self.drivingDigioStateAuto = self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "pin") {
                  self.drivingDigioPin = self.physicalData[i].value;
                  self.drivingDigioPinAuto = self.physicalData[i].auto_id;
                }
                if (self.physicalData[i].key_name === "landmark") {
                  self.drivingDigioLand = self.physicalData[i].value;
                  self.drivingDigioLandAuto = self.physicalData[i].auto_id;
                }
              }
            } else {
              self.voterVerifiedFlag = "None";
            }

            self.digiLocDrive = self.poaData.filter(
              item => item.source == "Digilocker-driving_license"
            );
            if (self.digiLocDrive.length > 0) {
              self.poaDataAvailable = "Edit";
              self.ovdAddressType = "Digilocker-driving_license";
              for (var i = 0; i < self.digiLocDrive.length; i++) {
                if (self.digiLocDrive[i].key_name === "c/o") {
                  self.drivingDigioCO = self.digiLocDrive[i].value;
                  self.drivingDigioCOAuto = self.digiLocDrive[i].auto_id;
                }
                if (self.digiLocDrive[i].key_name === "street") {
                  self.drivingDigioStreet = self.digiLocDrive[i].value;
                  self.drivingDigioStreetAuto = self.digiLocDrive[i].auto_id;
                }

                if (self.digiLocDrive[i].key_name === "locality") {
                  self.drivingDigioLocality = self.digiLocDrive[i].value;
                  self.drivingDigioLocalityAuto = self.digiLocDrive[i].auto_id;
                }

                if (self.digiLocDrive[i].key_name === "city") {
                  self.drivingDigioCity = self.digiLocDrive[i].value;
                  self.drivingDigioCityAuto = self.digiLocDrive[i].auto_id;
                }
                if (self.digiLocDrive[i].key_name === "district") {
                  self.drivingDigioDistrict = self.digiLocDrive[i].value;
                  self.drivingDigioDistrictAuto = self.digiLocDrive[i].auto_id;
                }
                if (self.digiLocDrive[i].key_name === "state") {
                  self.drivingDigioState = self.digiLocDrive[i].value;
                  self.drivingDigioStateAuto = self.digiLocDrive[i].auto_id;
                }
                if (self.digiLocDrive[i].key_name === "pin") {
                  self.drivingDigioPin = self.digiLocDrive[i].value;
                  self.drivingDigioPinAuto = self.digiLocDrive[i].auto_id;
                }
                if (self.digiLocDrive[i].key_name === "landmark") {
                  self.drivingDigioLand = self.digiLocDrive[i].value;
                  self.drivingDigioLandAuto = self.digiLocDrive[i].auto_id;
                }
              }
            } else {
              self.voterVerifiedFlag = "None";
            }

            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
        });
    },

    editAddressPoa() {
      this.poaDataAvailable = "Save";
    },
    editAddressPob() {
      this.pobDataAvailable = "Save";
    },

    saveClickVoter() {
      var self = this;
      self.$store.commit("routeChange", "start");

      var custId = Number(self.$route.query.data);

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/kycServices/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        customer_id: custId,
        profile_id: Number(self.profileId),
        kyc_verification_id: self.kycVerificationId,
        source: "Digio-voter_id",
        source_type: "POA",

        data: [
          {
            auto_id: self.voterRetrieveNumberAuto,
            key_name: "voterid_number",
            value: self.voterRetrieveNumber
          },
          {
            auto_id: self.voterRetrieveNameAuto,
            key_name: "voterid_name",
            value: self.voterRetrieveName
          },
          {
            auto_id: self.voterRetrievePermAddAuto,
            key_name: "voterid_address",
            value: self.voterRetrievePermAdd
          },
          {
            auto_id: self.voterFatherNameAuto,
            key_name: "voterid_father_name",
            value: self.voterFatherName
          },
          {
            auto_id: self.voterDateOfIssueAuto,
            key_name: "voterid_date_of_issue",
            value: self.voterDateOfIssue
          },
          {
            auto_id: self.voterDOBAuto,
            key_name: "voterid_dob",
            value: self.$moment(self.voterDOB).format("YYYY-MM-DD")
          },

          {
            auto_id: self.voterGenderAuto,
            key_name: "voterid_gender",
            value: self.voterGender
          }
        ]
      };
      // var timestamp = Math.round(+new Date() / 1000);

      instance
        .put("CustomerKycDetails/", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.successFlag === true) {
            self.voterVerifiedFlag = "showButton";
            // self.kycVerificationCheck()
            self.editoptionvoter = false;
            self.kycData();
            self.$store.commit("routeChange", "end");
          } else {
            self.$store.commit("routeChange", "end");
            // self.alert = true;
            // self.alertMessage = JSONData.data.message;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },

    saveOvdDetails() {
      var self = this;
      self.$store.commit("routeChange", "start");

      var custId = Number(self.customerId);

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/kycServices/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        customer_id: custId,
        profile_id: Number(self.viewProfileId),
        kyc_verification_id: self.kycVerificationIdPrimary,
        source: self.ovdAddressType,
        source_type: "POA",

        data: [
          {
            auto_id: self.drivingDigioCOAuto,
            key_name: "c/o",
            value: self.drivingDigioCO
          },
          {
            auto_id: self.drivingDigioStreetAuto,
            key_name: "street",
            value: self.drivingDigioStreet
          },
          {
            auto_id: self.drivingDigioLocalityAuto,
            key_name: "locality",
            value: self.drivingDigioLocality
          },
          {
            auto_id: self.drivingDigioCityAuto,
            key_name: "city",
            value: self.drivingDigioCity
          },
          {
            auto_id: self.drivingDigioDistrictAuto,
            key_name: "district",
            value: self.drivingDigioDistrict
          },
          {
            auto_id: self.drivingDigioStateAuto,
            key_name: "state",
            value: self.drivingDigioState
          },
          {
            auto_id: self.drivingDigioPinAuto,
            key_name: "pin",
            value: self.drivingDigioPin
          },
          {
            auto_id: self.drivingDigioLandAuto,
            key_name: "landmark",
            value: self.drivingDigioLand
          }
        ]
      };
      // var timestamp = Math.round(+new Date() / 1000);

      instance
        .put("CustomerKycDetails/", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.successFlag === true) {
            self.poaDataAvailable = "Edit";
            self.getKycVerificationID();

            self.$store.commit("routeChange", "end");
          } else {
            self.$store.commit("routeChange", "end");
            // self.alert = true;
            // self.alertMessage = JSONData.data.message;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },

    panFormatValidation() {
      var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
      return regpan.test(this.panNumber) ? true : false;
    },

    fetchPanDetailsNew() {
      this.alert = true;
      this.alertMessage = "Please save basic details";
    },

    fetchPanDetails() {
      if (this.panFormatValidation() && this.panNumber.length > 0) {
        this.errorPan = false;

        var self = this;
        self.$store.commit("routeChange", "start");

        const instance = axios.create({
          // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/mintLoan/mintloan/', //LIVE
          baseURL: "https://uatgateway.supermoney.in/kycservice/kyc/",
          // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //DEV
          // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //live
          headers: { "content-type": "application/json" }
        });

        //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
        var data = {
          client_id: "smartdash",
          payload: {
            panNo: self.panNumber,
            fetchLiveData: true
          },
          request_id: self.customerId,
          requester_id: self.$store.getters.loginId,
          service_provider_name: "NIL"
        };
        instance
          .post("fetchPANV2", data)

          .then(function (response) {
            console.log(response);
            const JSONData = response.data;
            if (JSONData.resp_status === "SUCCESS") {
              console.log("this is pan data");
              self.panDetailsFlag = true;
              self.panDetails = JSONData.payload;
              // self.getKycVerifyID()

              self.pan = self.panDetails.pan;
              self.title = self.panDetails.title;
              self.name = self.panDetails.name;
              self.firstName = self.panDetails.firstName;
              self.middleName = "";
              self.lastName = self.panDetails.lastName;
              self.typeOfHolder = self.panDetails.typeOfHolder;
              self.aadhaarSeedingStatus = self.panDetails.aadhaarSeedingStatus;
              self.lastUpdatedOn = self.panDetails.lastUpdatedOn;
              self.userName = JSONData.payload.name;
              self.storePANData();
            } else {
              self.panDetails = [];
              self.alert = true;
              self.alertMessage =
                "Details Cannot Be Fetched. Try Another PAN Number";
            }
            self.$store.commit("routeChange", "end");
            self.progress = false;
          })
          .catch(error => {
            console.log("this is the error to be shwow", +error);
            // self.alert = true;
            // self.alertMessage = "Server Connection Failed";
            self.$store.commit("routeChange", "end");
          });
      } else {
        this.errorPan = true;
        this.errorPanMsg = "Enter correct PAN number";
      }
    },

    poiPanData() {
      this.$store.commit("routeChange", "start");
      var self = this;

      var url =
        "https://uatgateway.supermoney.in/kycServices/CustomerKycDetails/?kyc_verification_id=" +
        self.kycVerificationIdPrimary +
        "&customer_id=" +
        self.customerId +
        "&source_type=POI";
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            self.poiData = JSONData.data;

            if (self.poiData.length > 0) {
              // self.kycVerificationPOICheckSet();

              for (var i = 0; i < self.poiData.length; i++) {
                if (self.poiData[i].key_name === "pan") {
                  self.panNo = self.poiData[i].value;
                }

                if (self.poiData[i].key_name === "pan_status") {
                  self.panStatus = self.poiData[i].value;
                }

                if (self.poiData[i].key_name === "name") {
                  self.panName = self.poiData[i].value;
                }

                if (self.poiData[i].key_name === "pan_legalEntityType") {
                  self.typeOfHolder = self.poiData[i].value;
                }

                if (self.poiData[i].key_name === "pan_title") {
                  self.panTitle = self.poiData[i].value;
                }
                if (self.poiData[i].key_name === "pan_firstName") {
                  self.panFirstName = self.poiData[i].value;
                }
                if (self.poiData[i].key_name === "pan_middleName") {
                  self.panMiddleName = self.poiData[i].value;
                }
                if (self.poiData[i].key_name === "pan_lastName") {
                  self.panLastName = self.poiData[i].value;
                }

                if (self.poiData[i].key_name === "pan_aadharSeedingStatus") {
                  self.aadharStatus = self.poiData[i].value;
                }

                // aadharStatus:'',
                // lastUpdatedOn:'',
                // additionalStatus:'',
              }
            } else {
              self.poiVerifiedFlag = "None";
            }
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
        });
    },
    storePANData() {
      var self = this;
      self.$store.commit("routeChange", "start");

      var custId = Number(self.customerId);

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/kycServices/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        data: [
          {
            source: "PAN",
            data: {
              login_id: self.loginId,
              typeOfHolder: self.panDetails.typeOfHolder,
              firstName: self.panDetails.firstName,
              lastName: self.panDetails.lastName,
              pan_number: self.panDetails.pan,
              middleName: self.panDetails.middleName,
              aadhaarSeedingStatus: self.panDetails.aadhaarSeedingStatus,
              title: self.panDetails.title,
              panStatus: self.panDetails.panStatus,
              pan_name: self.panDetails.name
            }
          }
        ],
        customer_id: JSON.stringify(custId),
        profile_id: self.viewProfileId,
        kyc_verification_id: self.kycVerificationIdPrimary
      };

      // var timestamp = Math.round(+new Date() / 1000);

      instance
        .post("CustomerKycDetails/", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.successFlag == true) {
            self.customerProfile();
            console.log("this is pan data");

            self.$store.commit("routeChange", "end");
          } else {
            self.$store.commit("routeChange", "end");
            self.alert = true;
            self.alertMessage = JSONData.errorDetails.errorMessage;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("this is the error", error);
          // self.alert = true;
          // self.alertMessage = "Server Connection Failed";
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },
    handleFileUploadOne() {
      console.log("this is the file");
      this.file = this.$refs.files.files[0];
      this.fileName = this.file.name;
      this.fileNameNew = '"' + this.fileName + '"';
      this.fileNameSet = this.fileName.substring(0, 20);
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
      this.uploadDocument();
    },

    uploadDocument() {
      if (this.fileNameNew.length > 0) {
        this.alert = false;
        this.$store.commit("routeChange", "start");
        var url =
          "https://uatgateway.supermoney.in//mintLoan/mintloan/uploadFile";
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append(
          "data",
          '{"custid":"407", "filetype":"OTHER", "filename":' +
          this.fileNameNew +
          ', "access": "PRIVATE"}'
        );
        formData.append(
          "msgHeader",
          '{ "loginId":"' +
          this.loginId +
          '","consumerId":"414", "authToken":"' +
          localStorage.getItem("authtoken") +
          '","channelType":"M","deviceId":"SwiggyLoans","source":"webDirect"}'
        );

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            const JSONData = response.data;
            var successFlag = JSONData.data.successFlag;

            if (successFlag === true) {
              this.fileLoaction = JSONData.data.fileLocation;
              this.frontPubLocation = JSONData.data.pubFileLocation;

              this.uploadStatus();
            } else {
              if (JSONData.header.hostStatus === "E") {
                this.errorAadharImg = true;

                this.errorAadharImgText = JSONData.header.error.errorDesc;
                if (JSONData.header.error.errorDesc === "") {
                  this.errorAadharImgText =
                    JSONData.data.errorDetails.errorDesc;
                }
              } else {
                this.errorAadharImg = true;
                this.errorAadharImgText =
                  JSONData.data.errorDetails[0].errorDesc;
              }
              this.$store.commit("routeChange", "end");
            }
            // this.$store.commit("routeChange", "end");
          })
          .catch(function () {
            this.$store.commit("routeChange", "end");
            this.errorAadharImg = true;
            this.errorAadharImgText = "Server Connection Failed";
            this.$store.commit("routeChange", "end");
          });
      } else {
        this.uploadAddressFlag = true;
        this.uploadAddressMessage = "Please select file";
      }
    },

    uploadStatus() {
      var self = this;
      self.$store.commit("routeChange", "start");
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        profileId: self.viewProfileId,
        documentDetails: [
          {
            docSeqId: "",
            docStatus: "N",
            docTypeId: "100",
            docURL: self.fileLoaction
          }
        ]
      };
      var timestamp = Math.round(+new Date() / 1000);
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        loginId: self.loginId,
        channelType: "M",
        consumerId: "414",
        deviceId: "SwiggyLoans",
        source: "webDirect"
      };
      var deviceFPmsgHeader = {
        clientIPAddress: "192.168.0.122",
        connectionMode: "WIFI",
        country: "United States",
        deviceManufacturer: "Xiaomi",
        deviceModelNo: "Mi A2",
        dualSim: false,
        imeiNo: "09d9212a07553637",
        latitude: "",
        longitude: "",
        nwProvider: "xxxxxxxx",
        osName: "Android",
        osVersion: 28,
        timezone: "Asia/Kolkata",
        versionCode: "58",
        versionName: "5.5.1"
      };

      var employeeDetails = { data, deviceFPmsgHeader, msgHeader };
      instance
        .post("kycDocumentUploadStatus", employeeDetails)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.data.successFlag == true) {
            // self.documentGroup()
          }
          self.$store.commit("routeChange", "end");

          self.progress = false;
        })
        .catch(error => {
          self.errorText = "Network Error";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },

    handleFileUploadTwo() {
      console.log("this is the file");
      this.file = this.$refs.files.files[0];
      this.fileName = this.file.name;
      this.currentAddressName = "";
      this.fileNameNew = '"' + this.fileName + '"';
      this.fileNameSet = this.fileName.substring(0, 20);
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },

    editAddress() {
      this.basicDetAvail = false;
      // this.otrName = this.getName
      // this.otrDesignation = this.getDesignation
      // this.otrCntNumber = this.getLogin
      // this.otrEmail = this.getEmail
    },
    getType(value) {
      this.selectedType = value;
      console.log("this is the value sele", this.selectedType);
    },

    fetchApplicationId() {
      this.$store.commit("routeChange", "start");
      let self = this;

      const instance = axios.create({
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/mintLoan/mintloan/', //LIVE
        baseURL:
          "https://uatgateway.supermoney.in/supermoney-service/customer/application/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //live
        headers: { "content-type": "application/json" }
      });
      let request = {
        customerId: self.$route.query.data,
        programId: ""
      };

      instance
        .post("get", request)
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          self.getCustomerApplicationResponseList =
            JSONData.getCustomerApplicationResponseList;
          for (
            var i = 0;
            i < self.getCustomerApplicationResponseList.length;
            i++
          ) {
            self.stageDocFetch(
              self.getCustomerApplicationResponseList[i].applicationId
            );
          }
        })
        .catch(function (error) {
          // handle error
          const data = error.response.data;
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },

    stageDocFetch(applicationid) {
      var self = this;

      self.$store.commit("routeChange", "start");

      var custId = Number(self.$store.getters.customerID);

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/stage/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        customerId: Number(self.$route.query.data),
        profileId: self.viewProfileID,
        stageName: "KYC",
        applicationId: applicationid
      };
      // var timestamp = Math.round(+new Date() / 1000);

      instance
        .post("fetch/", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          console.log("this is true for the fetch", response.data);
          self.getKycStatus = JSONData[0].stageStatus;

          if (JSONData[0].stageStatus === "COMPLETED") {
            self.setStage = "COMPLETED";
          }

          // if (JSONData[0].stageName === "POA_ADDITIONAL_DOC") {
          //   self.additionalDocStage = JSONData[0].stageStatus;
          //   if (JSONData[0].stageStatus === "SENT") {
          //     self.smsButtonFlag = false;
          //   }
          //
          //   self.$store.commit("routeChange", "end");
          // } else {
          //   self.$store.commit("routeChange", "end");
          //   self.smsButtonFlag = true;
          //
          // }
          console.log("thid id yhr stahr", self.setStage);
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.smsButtonFlag = true;
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },

    fetchFinanceSupplierMapping() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/supermoney-service/supplier/financingPlan/get";
      axios.post(url, data, {
        headers: {
          "content-type": "application/json"
        }
      });
      let request = {
        supplierId: self.$route.query.supplierID,
        financePlanId: self.financePlan.financePlanDetails.financingPlanId
      };

      axios
        .post(url, request)
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          if (JSONData.data.length > 0) {
            self.cashbackDetails = JSONData.data[0];
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },

    fetchProgramDetails() {
      this.$store.commit("routeChange", "start");
      let self = this;
      let data = {
        customerId: self.customerId,
        applicationId: self.applicationId
      };
      let url =
        "https://uatgateway.supermoney.in/supermoney-service/customer/application/get";
      axios
        .post(url, data, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          const JSONData = response.data;
          self.viewProfileID =
            JSONData.getCustomerApplicationResponseList[0].profileId;
          self.programDetails =
            JSONData.getCustomerApplicationResponseList[0].programDetails;
          // self.singlepenaltyDetails()
          self.customerProfile();
          self.fetchFinancePlanForApplication();
          console.log("this is true", JSON.stringify(self.financingPlanList));
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
          self.$store.commit("routeChange", "end");
        });
    },

    fetchFinancePlanForApplication() {
      this.$store.commit("routeChange", "start");
      let self = this;
      let data = {
        applicationId: self.applicationId
      };
      let url =
        "https://uatgateway.supermoney.in/supermoney-service/application/finance/get";
      axios
        .post(url, data, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          const JSONData = response.data;
          self.financingPlanListMapped =
            JSONData.getApplicationFinancePlanMappingResp[0].financePlanDetails;
          if (self.financingPlanListMapped) {
            self.financeAddedFlag = true;
          }

          console.log("this is finance length mapped", self.financeAddedFlag);
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.financingPlanListMapped = [];
        })
        .finally(function () {
          // always executed
          self.$store.commit("routeChange", "end");
        });
    },

    documentGroup() {
      var self = this;
      self.docDataNew = [];
      self.customerDocnameList = [];
      self.docData = [];
      self.selfieUrl = "";
      self.businessProfdata = [];
      self.businessProofs = [];

      var url =
        "https://uatgateway.supermoney.in/crmbackend/CustomerKycDocument/?customer_id=" +
        self.customerId;

      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            // self.customerDocnameList = JSONData.data.DocumentGroupList
            self.customerDocnameList = [
              "Proof of Identity",
              "Proof of Address",
              "Proof of Business",
              "Ledger",
              "Bank Details",
              "Others"
            ];

            for (var i = 0; i < self.customerDocnameList.length; i++) {
              var key = self.customerDocnameList[i];

              if (JSONData.data.DocumentGroupData[key].length > 0) {
                self.docDataNew.push(JSONData.data.DocumentGroupData[key]);
              }

              self.docDataT = [].concat.apply([], self.docDataNew);
            }

            for (var i = 0; i < self.docDataT.length; i++) {
              if (self.docDataT[i].verification_status != "N") {
                self.docData.push(self.docDataT[i]);
              }
            }

            console.log("this is document", JSON.stringify(self.docDataNew));
            console.log("this is filtered doc", JSON.stringify(self.docData));

            for (var i = 0; i < self.docData.length; i++) {
              console.log(
                "this is the dacdata sect",
                self.docData[i].document_type_id
              );

              if (
                self.docData[i].document_type_id === 148 &&
                self.docData[i].verification_status != "N"
              ) {
                self.businessProofs.push(
                  "https://uatgateway.supermoney.in/python/" +
                  "mlS3Read?customerID=" +
                  self.$route.query.data +
                  "&docSeqID=" +
                  self.docData[i].doc_seq_id
                );
                self.businessProfdata.push(self.docData[i]);
              } else if (
                (self.docData[i].document_type_id === 105 &&
                  self.docData[i].verification_status != "N") ||
                (self.docData[i].document_type_id === 103 &&
                  self.docData[i].verification_status != "N")
              ) {
                self.selfieUrl =
                  "https://uatgateway.supermoney.in/python/" +
                  "mlS3Read?customerID=" +
                  self.$route.query.data +
                  "&docSeqID=" +
                  self.docData[i].doc_seq_id;
              }
            }

            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
        });
    },

    uppercase() {
      this.supplierName = this.code.toUpperCase();
    },

    onInputChange(text) {
      if (text === "" || text === undefined) {
        return;
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.banklist
        .filter(
          item => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1
        )
        .slice(0, this.limit);
      // const filteredDesigner = this.datasuggest.data[0].designers.filter(item => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1).slice(0, this.limit)
      // const  = filteredDevelopers.concat(filteredDesigner)
      this.filteredOptions = [
        {
          data: filteredData
        }
      ];
      console.log("this is ban list", JSON.stringify(this.filteredOptions));
    },

    supplierProgramMapping() {
      var self = this;
      self.$store.commit("routeChange", "start");

      console.log("this is set to true");
      // var url =
      //   "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/borrower/get";
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in//supermoney-service/supplier/program/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        programIds: [self.programDetails.programId],
        supplierIds: [self.supplierIDSet],
        createdBy: self.$store.getters.loginId
      };
      var timestamp = Math.round(+new Date() / 1000);

      instance
        .post("create", data)
        .then(function (response) {
          const JSONData = response.data;
          var successFlag = JSONData.status;

          if (successFlag === true) {
            this.bankListFun();
            this.getCommentList();
            this.fetchProgramDetails();
            this.getKycVerificationID();

            self.$store.commit("routeChange", "end");
          } else {
            var errors = JSONData.data.error[0].errorMessage;
            self.alertMessage = errors;
            self.alert = true;
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },

    bankListFun() {
      var self = this;
      self.$store.commit("routeChange", "start");

      // var plussym = "+91"
      //  var finalLogin = plussym + self.loginId

      // var url = '/mintLoan/mintloan/getBankDetails'
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",

        headers: { "content-type": "application/json" }
      });
      var data = {};
      var timestamp = Math.round(+new Date() / 1000);
      var msgHeader = {
        authToken: "", //dynamic
        loginId: "+918806766928",
        channelType: "M",
        consumerId: "414",
        deviceId: "Onboarding",
        source: "webDirect"
      };
      var deviceFPmsgHeader = {
        clientIPAddress: "192.168.0.122",
        connectionMode: "WIFI",
        country: "United States",
        deviceManufacturer: "Xiaomi",
        deviceModelNo: "Mi A2",
        dualSim: false,
        imeiNo: "09d9212a07553637",
        latitude: "",
        longitude: "",
        nwProvider: "xxxxxxxx",
        osName: "Android",
        osVersion: 28,
        timezone: "Asia/Kolkata",
        versionCode: "58",
        versionName: "5.5.1"
      };

      var employeeDetails = { data, deviceFPmsgHeader, msgHeader };
      instance
        .post("getBankDetails", employeeDetails)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          var hostStatus = JSONData.header.hostStatus;
          self.authToken = JSONData.header.authToken;

          if (hostStatus === "S" || hostStatus === "s") {
            self.banklist = JSONData.data.bankDetails;
            console.log(
              "this is the bank list",
              JSON.stringify(self.banklist[0])
            );
            self.$store.commit("routeChange", "end");
          } else {
            var errors = JSONData.header.error.errorMessage;
            self.errorText = errors;
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
        });
    },
    onSelected(item) {
      console.log("this is bank", JSON.stringify(item));
      this.bankID = item.item;
      this.setbankID = item.item.id;
      this.newBankName = item.item.name;
      console.log("this is bank", this.bankID);
      this.searchIFSC();
    },

    onSelectedIfcs(item) {
      console.log("this is bank", JSON.stringify(item));

      this.newIFSCcode = item.item.ifscCode;
      console.log("this is bank", this.newIFSCcode);
      // this.searchIFSC()
    },

    onInputChangeIfsc(text) {
      if (text === "" || text === undefined) {
        return;
      }

      if (text.length <= 3) {
        const filteredData = this.ifscDetails
          .filter(
            item => item.ifscCode.toLowerCase().indexOf(text.toLowerCase()) > -1
          )
          .slice(0, this.limit);

        this.filteredOptionsIfsc = [
          {
            data: filteredData
          }
        ];
        console.log(
          "this is ifsc list",
          JSON.stringify(this.filteredOptionsIfsc)
        );
      } else if (text.length > 4) {
        this.bankIfscNew(text);
      }
    },

    searchIFSC: function () {
      console.log("this is bank Id", this.bankID);
      this.bankIfsc = "";
      let self = this;
      self.$store.commit("routeChange", "start");
      let plussym = "+91";
      let finalLogin = plussym + self.loginId;

      // let url = "/mintLoan/mintloan/ifscSearch";
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      let data = {
        bankCode: self.bankID.id,
        searchTxt: self.bankID.name
      };

      instance
        .post("ifscSearchV2", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          self.ifscDetails = JSONData.ifscDetails;
          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
        });
    },

    bankIfscNew: function (a) {
      console.log("this is thw list");

      if (a.length > 4 && a.length < 11) {
        console.log("this is bank Id", this.bankID);

        let self = this;
        self.$store.commit("routeChange", "start");
        let plussym = "+91";
        let finalLogin = plussym + self.loginId;

        // let url = "/mintLoan/mintloan/ifscSearch";
        const instance = axios.create({
          baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",

          headers: { "content-type": "application/json" }
        });
        let data = {
          bankCode: self.setbankID,
          searchTxt: a
        };
        let timestamp = Math.round(+new Date() / 1000);
        let msgHeader = {
          authToken: "", //dynamic
          loginId: self.loginId,
          channelType: "M",
          consumerId: "414",
          deviceId: "BankMandate",
          source: "webDirect"
        };
        let deviceFPmsgHeader = {
          clientIPAddress: "192.168.0.122",
          connectionMode: "WIFI",
          country: "United States",
          deviceManufacturer: "Xiaomi",
          deviceModelNo: "Mi A2",
          dualSim: false,
          imeiNo: "09d9212a07553637",
          latitude: "",
          longitude: "",
          nwProvider: "xxxxxxxx",
          osName: "Android",
          osVersion: 28,
          timezone: "Asia/Kolkata",
          versionCode: "58",
          versionName: "5.5.1"
        };

        let employeeDetails = { data, deviceFPmsgHeader, msgHeader };
        instance
          .post("ifscSearch", employeeDetails)
          .then(function (response) {
            console.log(response);
            const JSONData = response.data;
            let hostStatus = JSONData.header.hostStatus;
            self.authToken = JSONData.header.authToken;

            if (hostStatus === "S") {
              self.ifscDetails = JSONData.data.ifscDetails;

              const filteredData = self.ifscDetails
                .filter(
                  item =>
                    item.ifscCode.toLowerCase().indexOf(a.toLowerCase()) > -1
                )
                .slice(0, self.limit);

              self.filteredOptionsIfsc = [
                {
                  data: filteredData
                }
              ];

              self.$store.commit("routeChange", "end");
            } else {
              let errors = JSONData.data.error[0].errorMessage;
              self.alert = true;
              self.alertMessage = errors;
              self.$store.commit("routeChange", "end");
            }
          })
          .catch(function (error) {
            // handle error
            console.log("display  ==" + error);
          })
          .finally(function () {
            // always executed
          });
      }
    },

    dismissPopSupplier() {
      this.dismissPOPTe();
      this.$refs.routerView[this.$route.meta.hitCreateSupplier.methodName]();

      this.notSuccess = false;
      this.supplierFlag = false;
      this.showSupBankFalg = true;
      this.newBankAccNo = "";
      this.newBankName = "";
      this.accontName = "";
      this.newIFSCcode = "";
      this.newAccountype = "";
      this.supplierName = "";
      this.supplierGSTNo = "";
      this.supplierEmailID = "";
      this.supplierPhoneNo = "";
      this.newBranch = "";
      this.customerProfile();
      this.bankListFun();
    },

    open() {
      this.$vm2.open("modal-1");
    },
    close() {
      this.$vm2.close("modal-1");
    },

    customerProfile() {
      this.$store.commit("routeChange", "start");
      var self = this;

      // var url = "/mintLoan/mintloan/customerProfile";
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var request = {
        loginId: self.loginId,
        applicationId: self.applicationId
      };

      instance
        .post("customerProfile", request)
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          const JSONData = response.data;
          if (JSONData.errorMessage === "") {
            self.secondaryProfileList =
              JSONData.profileIdList.secondaryProfileId;
            // self.fixedProfileList = JSONData.profileIdList.secondaryProfileId
            //       self.secondaryProfileList.forEach((item, index)=>{
            //
            //         self.$set(
            //   self.secondaryProfileList[index],
            //   "newPartner",
            //   false
            // );
            //       })
            console.log(
              "this is the profile list",
              JSON.stringify(self.secondaryProfileList.length)
            );
            if (self.secondaryProfileList.length === 0) {
              self.NewDirectorFlag = true;
              self.showOnceBtn = false;
            }
            self.changeActive(0);
          } else {
            self.alert = true;
            self.alertMessage = JSONData.errorMessage;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    AssignError() {
      this.alert = true;
      this.alertMessage =
        "Please confirm customer details before assigning for KYC verification";
    },

    dismissPOPTe() {
      console.log("this was entered");
      this.supplierFlag = false;

      this.notSuccess = false;
    },

    popTempFun() {
      document.getElementById("popup1").style.display = "block";
    },

    gstFormatValidation() {
      let regpan = /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
      return regpan.test(this.supplierGSTNo) ? true : false;
    },
    emailValidation() {
      let regpan = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regpan.test(this.supplierEmailID) ? true : false;
    },
    nameValidation() {
      let regpan = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
      return regpan.test(this.supplierName) ? true : false;
    },

    removeDuplicateCharacters(string) {
      let temp = string
        .split("")
        .filter(function (item, pos, self) {
          return self.indexOf(item) == pos;
        })
        .join("");
      return temp.length;
    },
    checkInitialLetter(string) {
      return parseInt(string.split("")[0]) > 4 ? true : false;
    },
    addSupplierClick() {
      // document.getElementById("myModalNew").style.display='block'
      this.supplierFlag = true;
      // this.$vm2.open('modal-1')
    },
    ifscFormatValidation() {
      var regpan = /^[A-Za-z]{4}\d{7}$/;
      return regpan.test(this.newIFSCcode) ? true : false;
    },

    nameFormatValidation() {
      var regpan = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
      return regpan.test(this.accontName) ? true : false;
    },

    addSupplier() {
      var character = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
      if (character.test(this.newBankAccNo)) {
        this.accuntFlag = false;
      } else {
        this.accuntFlag = true;
      }

      if (character.test(this.newIFSCcode)) {
        this.ifscFlag = false;
      } else {
        this.ifscFlag = true;
      }

      if (this.newBankName != "") {
        this.bankNameFlag = false;
        if (
          this.newBankAccNo != "" &&
          this.newBankAccNo.length >= 8 &&
          this.accuntFlag === true
        ) {
          this.accErrorFlag = false;
          if (this.accontName.length > 2) {
            this.holderFlag = false;
            if (this.newIFSCcode != "" && this.ifscFlag === true) {
              this.ifscCodeFlag = false;
              if (this.newBranch != "") {
                this.branchFlag = false;

                if (this.newAccountype != "") {
                  this.accTypeFlag = false;
                  var self = this;
                  self.$store.commit("routeChange", "start");
                  // var url = "/mintLoan/mintloan/invoiceFinancing";
                  const instance = axios.create({
                    baseURL:
                      "https://uatgateway.supermoney.in/mintLoan/mintloan/",
                    // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
                    // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
                    // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
                    headers: { "content-type": "application/json" }
                  });
                  var data = {
                    invoiceType: "createSupplier",
                    request: {
                      companyName: self.companyName,
                      borrowerId: self.borrowerId,
                      planCode: "0@JIO_INAUGRAL",
                      name: self.supplierName,
                      phoneNumber: self.supplierPhoneNo,
                      email: self.supplierEmailID,
                      pan: "",
                      gstinNumber: self.supplierGSTNo,
                      address: "",
                      city: "",
                      state: "",
                      pincode: "",
                      ifscCode: self.newIFSCcode,
                      accountNo: self.newBankAccNo,
                      externalId: "",
                      accountHolderName: self.accontName,
                      accountType: self.newAccountype,
                      bankName: self.newBankName,
                      branch: self.newBranch,
                      branchCity: self.newBranch,
                      micrCode: "",
                      documentStatus: "Under Process",
                      docUrl: "",
                      netbankEnabled: false,
                      maxDaysForFinance: 25
                    }
                  };
                  var timestamp = Math.round(+new Date() / 1000);
                  var msgHeader = {
                    authToken: "", //dynamic
                    loginId: self.loginId,
                    channelType: "M",
                    consumerId: "414",
                    deviceId: "BankMandate",
                    source: "webDirect"
                  };
                  var deviceFPmsgHeader = {
                    clientIPAddress: "192.168.0.122",
                    connectionMode: "WIFI",
                    country: "United States",
                    deviceManufacturer: "Xiaomi",
                    deviceModelNo: "Mi A2",
                    dualSim: false,
                    imeiNo: "09d9212a07553637",
                    latitude: "",
                    longitude: "",
                    nwProvider: "xxxxxxxx",
                    osName: "Android",
                    osVersion: 28,
                    timezone: "Asia/Kolkata",
                    versionCode: "58",
                    versionName: "5.5.1"
                  };

                  var employeeDetails = { data, deviceFPmsgHeader, msgHeader };
                  instance
                    .post("invoiceFinancing", employeeDetails)
                    .then(function (response) {
                      console.log(response);
                      const JSONData = response.data;

                      var hostStatus = JSONData.data.successFlag;
                      // self.authToken = JSONData.header.authToken

                      if (hostStatus === true) {
                        self.$store.commit("routeChange", "end");
                        self.supplierIDSet = JSONData.data.details.supplierId;
                        self.supplierProgramMapping();
                        self.allErrorFlag = false;
                        self.bankNameFlag = false;
                        self.notSuccess = true;
                      } else {
                        if (JSONData.header.hostStatus === "E") {
                          self.allErrorFlag = true;
                          self.allErrorMessage =
                            JSONData.header.error.errorDesc;
                          self.$store.commit("routeChange", "end");
                        } else {
                          self.allErrorFlag = true;
                          self.allErrorMessage =
                            JSONData.data.details.errors[0];
                          self.$store.commit("routeChange", "end");
                        }
                      }
                    })
                    .catch(function (error) {
                      // handle error
                      self.allErrorFlag = true;
                      self.allErrorMessage = "Server Connection Failed";
                      self.$store.commit("routeChange", "end");
                      console.log("display  ==" + error);
                    })
                    .finally(function () {
                      // always executed
                    });
                } else {
                  this.accTypeFlag = true;
                  this.accTypeError = "Please Select Account Type";
                }
              } else {
                this.branchFlag = true;
                this.branchError = "Please Enter Branch";
              }
            } else {
              this.ifscCodeFlag = true;
              this.ifscCodeError = "Please Enter Valid IFSC Code";
            }
          } else {
            this.holderFlag = true;
            this.holderError = "Please Enter Valid Account Holder Name";
          }
        } else {
          this.accErrorFlag = true;
          this.accFlagMessage = "Please Enter Valid Bank Account Number";
        }
      } else {
        this.bankNameFlag = true;
        this.bankNameError = "Please Enter Valid Bank Name";
      }
    },

    nextBtn() {
      if (this.supplierName.length > 1) {
        this.nameFlag = false;
        if (this.supplierGSTNo != "" && this.gstFormatValidation()) {
          this.gstFlag = false;
          if (
            this.supplierPhoneNo.length === 10 &&
            this.removeDuplicateCharacters(this.supplierPhoneNo) > 1 &&
            this.checkInitialLetter(this.supplierPhoneNo)
          ) {
            this.phoneFlag = false;
            if (this.supplierEmailID != "" && this.emailValidation()) {
              this.showSupBankFalg = false;
            } else {
              this.emailFlag = true;
              this.emailFlagMessage = "Please Enter Valid Email ID";
            }
          } else {
            this.phoneFlag = true;
            this.phoneFlagMessage = "Please Enter Valid Mobile Number";
          }
        } else {
          this.gstFlag = true;
          this.gstFlagMessage = "Please Enter Valid GST Number";
        }
      } else {
        this.nameFlag = true;
        this.nameFlagMessage = "Please Enter Valid Supplier Name";
      }
    },
    supplierList() {
      var self = this;
      self.$store.commit("routeChange", "start");

      // var url =
      //   "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/borrower/get";
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/borrower/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        borrowerId: self.borrowerId
      };
      var timestamp = Math.round(+new Date() / 1000);

      instance
        .post("get", data)
        .then(function (response) {
          const JSONData = response.data;
          var successFlag = JSONData.borrowerId;

          if (successFlag != "") {
            //self.fileUploaded = true
            //
            // for (var i = 0; i < JSONData.suppliers.length; i++) {
            //   if (JSONData.suppliers[i].supplierStatus != "Reject")
            //   {
            //     console.log("this is true",JSONData.suppliers[i].supplierStatus)
            self.suppliersList = JSONData.suppliers;
            // }
            // }

            self.$store.commit("routeChange", "end");
          } else {
            var errors = JSONData.data.error[0].errorMessage;
            self.alertMessage = errors;
            self.alert = true;
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },

    createBorrower() {
      var self = this;

      self.$store.commit("routeChange", "start");
      var custId = Number(self.customerId);
      // var url = "/mintLoan/mintloan/invoiceFinancing";

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        invoiceType: "createBorrower",
        request: {
          companyName: self.companyName,
          supplierId: "",
          planCode: "0@JIO_INAUGRAL",
          supplierBankDetailId: "1",
          name: self.borrowerName,
          phoneNumber: self.loginId,
          email: "",
          pan: self.panNumber,
          gstinNumber: "",
          ifsc: "",
          bankAccountNo: "",
          externalId: JSON.stringify(custId),
          applicationId: self.applicationId
        }
      };
      var timestamp = Math.round(+new Date() / 1000);
      var msgHeader = {
        authToken: "webDirect", //dynamic
        loginId: self.loginId,
        channelType: "M",
        consumerId: "414",
        deviceId: "BankMandate",
        source: "webDirect"
      };
      var deviceFPmsgHeader = {
        clientIPAddress: "192.168.0.122",
        connectionMode: "WIFI",
        country: "United States",
        deviceManufacturer: "Xiaomi",
        deviceModelNo: "Mi A2",
        dualSim: false,
        imeiNo: "09d9212a07553637",
        latitude: "",
        longitude: "",
        nwProvider: "xxxxxxxx",
        osName: "Android",
        osVersion: 28,
        timezone: "Asia/Kolkata",
        versionCode: "58",
        versionName: "5.5.1"
      };

      console.log("this is true");

      var employeeDetails = { data, deviceFPmsgHeader, msgHeader };
      instance
        .post("invoiceFinancing", employeeDetails)
        .then(function (response) {
          const JSONData = response.data;

          var hostStatus = JSONData.data.successFlag;
          // self.authToken = JSONData.header.authToken

          if (hostStatus === true) {
            self.$store.commit("routeChange", "end");

            self.borrowerId = JSONData.data.details.borrowerId;
          } else {
            if (JSONData.header.hostStatus === "E") {
              self.alertMessage = JSONData.header.error.errorDesc;
              self.alert = true;
            } else {
              self.alertMessage = JSONData.data.details.errors[0];
              self.alert = true;
            }
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },

    confirmDetails() {
      this.confirmDetailsFlag = true;
    },
    dismissPOP() {
      this.confirmDetailsFlag = false;
    },

    changeStageInformation() {
      // if (this.suppliersList.length > 0) {
      // if(this.businessProfdata.length > 0)
      // {
      //   if(this.selfieUrl.length > 0)
      //   {
      if (this.financeAddedFlag == true) {
        var self = this;

        self.$store.commit("routeChange", "start");

        const instance = axios.create({
          baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/stage/",
          // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
          // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
          // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
          headers: { "content-type": "application/json" }
        });
        var data = {
          customerId: Number(self.customerId),
          profileId: Number(self.viewProfileID),
          stageName: "Onboarding",
          stageStatus: "INFORMATION_PROVIDED",
          applicationId: self.applicationId,
          relatedId: ""
        };
        // var timestamp = Math.round(+new Date() / 1000);

        instance
          .post("update", data)
          .then(function (response) {
            console.log(response);
            const JSONData = response.data;

            if (JSONData.successFlag === true) {
              self.confirmDetailsFlag = false;
              self.customerProfile();
              self.stageCreateKYC();
              // self.changeActive(self.selectedButton);
              self.$store.commit("routeChange", "end");
            } else {
              self.$store.commit("routeChange", "end");
              self.alert = true;
              self.alertMessage = JSONData.data.message;
            }
          })
          .catch(function (error) {
            // handle error
            console.log("this is the error", error);
            // self.alert = true;
            // self.alertMessage = "Server Connection Failed";
            console.log("display  ==" + error);
            self.$store.commit("routeChange", "end");
          })
          .finally(function () {
            // always executed
          });
      } else {
        this.alert = true;
        this.alertMessage = "Please select a financing plan";
      }
      // }
      // else
      // {
      //   this.alert = true;
      //   this.alertMessage =
      //     "Please upload Photo/ Profile Picture in Documents section";
      // }
      // }
      // else
      // {
      //   this.alert = true;
      //   this.alertMessage =
      //     "Please upload any business proof in Documents section";
      // }
      // }
      // else {
      //   this.alert = true;
      //   this.alertMessage =
      //     "Please add supplier before confirming customer details";
      // }
    },

    fetchStage() {
      var self = this;

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/stage/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        customerId: Number(self.customerId),
        profileId: Number(self.viewProfileID),
        stageName: "Onboarding",
        applicationId: self.applicationId,
        relatedId: ""
      };
      // var timestamp = Math.round(+new Date() / 1000);

      instance
        .post("fetch", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData[0].stageStatus === "INFORMATION_PROVIDED") {
            self.confirmFlag = true;
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("this is the error", error);
          // self.alert = true;
          // self.alertMessage = "Server Connection Failed";
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },

    stageCreateKYC() {
      var self = this;
      // if(self.confirmFlag == true)
      // {
      var stageName = "";

      if (self.setStage === "COMPLETED") {
        stageName = "COMPLETED";
      } else {
        stageName = "INITIATED";
      }

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/stage/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        customerId: Number(self.customerId),
        profileId: Number(self.viewProfileID),
        stageName: "KYC",
        stageStatus: stageName,
        kycVerificationId: self.kycVerificationIdPrimary,
        relatedId: "",
        applicationId: self.applicationId
      };
      // var timestamp = Math.round(+new Date() / 1000);

      instance
        .post("update", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.successFlag === true) {
            self.$store.commit("routeChange", "end");
          } else {
            self.$store.commit("routeChange", "end");
            self.alert = true;
            self.alertMessage = JSONData.data.message;
          }
        })
        .catch(function (error) {
          // handle error
          // self.alert = true;
          // self.alertMessage = "Server Connection Failed";
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
      // }
      // else
      // {
      //   self.alert = true
      //   self.alertmessage = "Please confirm customer details before assigning for KYC verification"
      // }
    },

    getKycVerificationID(secondprofileID) {
      this.$store.commit("routeChange", "start");
      this.secondaryProfileSet = secondprofileID;
      var self = this;

      var url =
        "https://uatgateway.supermoney.in/kycServices/getKycVeriId/?customer_id=" +
        self.customerId;
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            self.profileIDs = JSONData.data.profiles;
            for (var i = 0; i < self.profileIDs.length; i++) {
              if (
                Number(self.profileIDs[i].profileId) === Number(secondprofileID)
              )
                self.profileId = self.profileIDs[i];
            }

            console.log("this is the profile id Program", secondprofileID);
            console.log(
              "this is the profile id",
              JSON.stringify(self.profileId)
            );
            self.NewDirectorFlag = false;
            self.viewProfileId = self.profileId.profileId;
            for (var i = 0; i < self.profileId.kycIds.length; i++) {
              if (self.profileId.kycIds[i].archived === "N")
                self.kycVerificationIdPrimary =
                  self.profileId.kycIds[i].kyc_verification_id;
              // self.poiPanData();
              self.getStatusKYC();
              self.poiPanData();
              self.getPOAData();
              self.kycDocuments();

              // self.supplierList();
            }

            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          self.$store.commit("routeChange", "end");
          // handle error
        })
        .finally(function () {
          // always executed
        });
    },

    getStatusKYC() {
      var self = this;
      var url =
        "https://uatgateway.supermoney.in/kycServices/CustomerKycDetails/?kyc_verification_id=" +
        self.kycVerificationIdPrimary +
        "&customer_id=" +
        self.customerId +
        "&source_type=CUSTOMER";
      // var url = 'https://uatgateway.supermoney.in/kycServices/CustomerKycDetails/?kyc_verification_id='+self.profile.kycIds[0].kyc_verification_id+'&customer_id='+self.$route.query.data+'&source_type=CUSTOMER';
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            self.customerData = JSONData.data;
            if (self.customerData.length > 0) {
              for (var i = 0; i < self.customerData.length; i++) {
                self.basicDetAvail = true;

                if (self.customerData[i].key_name === "director_name") {
                  self.custName = self.customerData[i].value;
                  self.custNameAuto = self.customerData[i].auto_id;
                }
                if (
                  self.customerData[i].key_name ===
                  "director_shareholding_percentage"
                ) {
                  self.custShareHolding = self.customerData[i].value;
                  self.custShareHoldingAuto = self.customerData[i].auto_id;
                }
                if (
                  self.customerData[i].key_name === "director_identification_no"
                ) {
                  self.custDIN = self.customerData[i].value;
                  self.custDINAuto = self.customerData[i].auto_id;
                }
                if (
                  self.customerData[i].key_name === "director_appointment_date"
                ) {
                  self.custAptDate = self.customerData[i].value;
                  self.custAptDateAuto = self.customerData[i].auto_id;
                }

                if (
                  self.customerData[i].key_name === "director_mobile_number"
                ) {
                  self.custcontactNo = self.customerData[i].value;
                  self.custcontactNoAuto = self.customerData[i].auto_id;
                }
                if (self.customerData[i].key_name === "director_email") {
                  self.custEmailid = self.customerData[i].value;
                  self.custEmailidAuto = self.customerData[i].auto_id;
                }
              }
            } else {
              self.basicDetAvail = false;
            }

            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
        });
    },

    storeCustType() {
      if (this.custType === "Company") {
        this.storeCustomerData();
      } else {
        this.storeCustomerDataPartner();
      }
    },

    storeCustTypeNew() {
      if (this.custType === "Company") {
        this.storeCustomerDataNew();
      } else {
        this.storeCustomerDataPartnerNew();
      }
    },

    createKycId() {
      // for (var i = 0; i < this.noOfDirectors.length; i++) {
      //
      // }

      var tempCnt = Number(this.custcontactNoNew);
      var cntcNum = JSON.stringify(tempCnt);
      console.log("this is true");
      if (this.custType === "Company") {
        if (this.custNameNew.length > 0) {
          this.errorcustNameNew = false;
          if (
            Number(this.custShareHoldingNew <= 100) &&
            Number(this.custShareHoldingNew > 0)
          ) {
            console.log("this is the share holding", this.custShareHolding);
            this.errorcustShareHoldingNew = false;

            if (this.custDINNew.length === 8) {
              this.errorcustDINNew = false;
              var today = this.$moment(new Date()).format("YYYY-MM-DD");
              if (
                this.custAptDateNew < today &&
                this.custAptDateNew.length > 0
              ) {
                this.errorcustAptDateNew = false;

                if (
                  cntcNum.length === 10 &&
                  this.removeDuplicateCharacters(cntcNum) > 1 &&
                  this.checkInitialLetter(cntcNum)
                ) {
                  this.$store.commit("routeChange", "start");
                  let self = this;
                  let data = {
                    customerId: Number(self.customerId),
                    name: self.custNameNew,
                    gender: "Male",
                    dob: "",
                    doj: "",
                    address: "",
                    emailId: "",
                    lifeStage: "",
                    companyName: self.companyName,
                    legalEntityType: self.selectedTypeEntity,
                    onboardingPartner: ""
                  };
                  let url =
                    "https://uatgateway.supermoney.in/supermoney-service/customer/application/createSecondaryProfile";
                  axios
                    .post(url, data, {
                      headers: {
                        "content-type": "application/json"
                      }
                    })
                    .then(function (response) {
                      const JSONData = response.data;
                      if (JSONData.status === true) {
                        self.secondaryProfileIdNew = JSONData.profileId;

                        self.createNewKycId(self.secondaryProfileIdNew);
                      }
                    })
                    .catch(function (error) {
                      // handle error
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                      self.alert = true;
                      self.alertMessage = error.response.data.message;
                      console.log("display  ==" + error);
                      self.$store.commit("routeChange", "end");
                    })
                    .finally(function () {
                      // always executed
                      self.$store.commit("routeChange", "end");
                    });
                } else {
                  this.errorcustcontactNoNew = true;
                  this.errorcustcontactNoMsgNew = "Enter valid mobile no";
                }
              } else {
                this.errorcustAptDateNew = true;
                this.errorcustAptDateMsgNew = "Enter valid date";
              }
            } else {
              this.errorcustDINNew = true;
              this.errorcustDINMsgNew = "Enter valid DIN";
            }
          } else {
            this.errorcustShareHoldingNew = true;
            this.errorcustShareHoldingMsgNew = "Enter valid percentage";
          }
        } else {
          this.errorcustNameNew = true;
          this.errorcustNameMsgNew = "Enter name";
        }
      } else {
        if (this.custNameNew.length > 0) {
          this.errorcustNameNew = false;
          if (
            Number(this.custShareHoldingNew <= 100) &&
            Number(this.custShareHoldingNew > 0)
          ) {
            console.log("this is the share holding", this.custShareHolding);
            this.errorcustShareHoldingNew = false;

            if (
              cntcNum.length === 10 &&
              this.removeDuplicateCharacters(cntcNum) > 1 &&
              this.checkInitialLetter(cntcNum)
            ) {
              this.$store.commit("routeChange", "start");
              let self = this;
              let data = {
                customerId: Number(self.customerId),
                name: self.custNameNew,
                gender: "Male",
                dob: "",
                doj: "",
                address: "",
                emailId: "",
                lifeStage: "",
                companyName: self.companyName,
                legalEntityType: self.selectedTypeEntity,
                onboardingPartner: ""
              };
              let url =
                "https://uatgateway.supermoney.in/supermoney-service/customer/application/createSecondaryProfile";
              axios
                .post(url, data, {
                  headers: {
                    "content-type": "application/json"
                  }
                })
                .then(function (response) {
                  const JSONData = response.data;
                  if (JSONData.status === true) {
                    self.secondaryProfileIdNew = JSONData.profileId;

                    self.createNewKycId(self.secondaryProfileIdNew);
                  }
                })
                .catch(function (error) {
                  // handle error
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                  self.alert = true;
                  self.alertMessage = error.response.data.message;
                  console.log("display  ==" + error);
                  self.$store.commit("routeChange", "end");
                })
                .finally(function () {
                  // always executed
                  self.$store.commit("routeChange", "end");
                });
            } else {
              this.errorcustcontactNoNew = true;
              this.errorcustcontactNoMsgNew = "Enter valid mobile no";
            }
          } else {
            this.errorcustShareHoldingNew = true;
            this.errorcustShareHoldingMsgNew = "Enter valid percentage";
          }
        } else {
          this.errorcustNameNew = true;
          this.errorcustNameMsgNew = "Enter name";
        }
      }
    },

    createNewKycId(secondaryProfileId) {
      var self = this;

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/mintLoan/mintloan/', //LIVE
        baseURL: "https://uatgateway.supermoney.in/kycServices/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://mintwalk.com/tomcat/mintLoan/mintloan/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://mintwalk.com/tomcat/mintLoan/mintloan/', //live
        headers: { "content-type": "application/json" }
      });

      var my_randomstring = Math.random()
        .toString(36)
        .slice(-8);

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        workflow_id: "SM_OB_" + my_randomstring,
        profile_id: secondaryProfileId,
        customer_id: self.customerId
      };
      instance
        .post("getKycVeriId/", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.successFlag == true) {
            self.kycVerifyIDNew = JSONData.data.kyc_verification_id;
            self.storeCustTypeNew();
          } else {
            self.alert = true;
            self.alertMessage = JSONData.errorDetails.errorMessage;
          }
          self.$store.commit("routeChange", "end");
          self.progress = false;
        })
        .catch(error => {
          self.alertMessage = "Server Connection Failed";
          self.alert = true;
          self.$store.commit("routeChange", "end");
        });
    },

    storeCustomerDataPartner() {
      var tempCnt = Number(this.custcontactNo);
      var cntcNum = JSON.stringify(tempCnt);
      if (this.custName.length > 0) {
        this.errorcustName = false;
        if (
          Number(this.custShareHolding <= 100) &&
          Number(this.custShareHolding > 0)
        ) {
          console.log("this is the share holding", this.custShareHolding);
          this.errorcustShareHolding = false;

          if (
            cntcNum.length === 10 &&
            this.removeDuplicateCharacters(cntcNum) > 1 &&
            this.checkInitialLetter(cntcNum)
          ) {
            var self = this;
            self.$store.commit("routeChange", "start");

            var custId = Number(self.customerId);

            const instance = axios.create({
              baseURL: "https://uatgateway.supermoney.in/kycServices/",
              // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
              // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
              // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
              headers: { "content-type": "application/json" }
            });
            var data = {
              data: [
                {
                  source: "DIRECTOR_DETAIL",
                  data: {
                    name: self.custName,
                    shareholding_percentage: self.custShareHolding,
                    director_identification_no: self.custDIN,
                    appointment_date: self.custAptDate,
                    mobile_number: self.custcontactNo,
                    email: self.custEmailid
                  }
                }
              ],
              customer_id: JSON.stringify(custId),
              profile_id: self.viewProfileId,
              kyc_verification_id: self.kycVerificationIdPrimary
            };

            // var timestamp = Math.round(+new Date() / 1000);

            instance
              .post("CustomerKycDetails/", data)
              .then(function (response) {
                console.log(response);
                const JSONData = response.data;

                if (JSONData.successFlag == true) {
                  console.log("this is pan data");
                  self.basicDetAvail = true;
                  self.customerProfile();
                  self.$store.commit("routeChange", "end");
                } else {
                  self.$store.commit("routeChange", "end");
                  self.alert = true;
                  self.alertMessage = JSONData.errorDetails.errorMessage;
                }
              })
              .catch(function (error) {
                // handle error
                console.log("this is the error", error);
                // self.alert = true;
                // self.alertMessage = "Server Connection Failed";
                self.$store.commit("routeChange", "end");
              })
              .finally(function () {
                // always executed
              });
          } else {
            this.errorcustcontactNo = true;
            this.errorcustcontactNoMsg = "Enter valid mobile no";
          }
        } else {
          this.errorcustShareHolding = true;
          this.errorcustShareHoldingMsg = "Enter valid percentage";
        }
      } else {
        this.errorcustName = true;
        this.errorcustNameMsg = "Enter name";
      }
    },

    storeCustomerDataPartnerNew() {
      var self = this;
      self.$store.commit("routeChange", "start");

      var custId = Number(self.customerId);

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/kycServices/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
        headers: { "content-type": "application/json" }
      });
      var data = {
        data: [
          {
            source: "DIRECTOR_DETAIL",
            data: {
              name: self.custNameNew,
              shareholding_percentage: self.custShareHoldingNew,
              director_identification_no: self.custDINNew,
              appointment_date: self.custAptDateNew,
              mobile_number: self.custcontactNoNew,
              email: self.custEmailidNew
            }
          }
        ],
        customer_id: JSON.stringify(custId),
        profile_id: self.secondaryProfileIdNew,
        kyc_verification_id: self.kycVerifyIDNew
      };

      // var timestamp = Math.round(+new Date() / 1000);

      instance
        .post("CustomerKycDetails/", data)
        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.successFlag == true) {
            console.log("this is pan data");
            self.basicDetAvail = true;
            self.customerProfile();
            self.showOnceBtn = true;
            self.$store.commit("routeChange", "end");
          } else {
            self.$store.commit("routeChange", "end");
            self.alert = true;
            self.alertMessage = JSONData.errorDetails.errorMessage;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("this is the error", error);
          // self.alert = true;
          // self.alertMessage = "Server Connection Failed";
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },

    storeCustomerData() {
      var tempCnt = Number(this.custcontactNo);
      var cntcNum = JSON.stringify(tempCnt);
      if (this.custName.length > 0) {
        this.errorcustName = false;
        if (
          Number(this.custShareHolding <= 100) &&
          Number(this.custShareHolding > 0)
        ) {
          console.log("this is the share holding", this.custShareHolding);
          this.errorcustShareHolding = false;
          if (this.custDIN.length === 8) {
            this.errorcustDIN = false;
            var today = this.$moment(new Date()).format("YYYY-MM-DD");
            if (this.custAptDate < today && this.custAptDate.length > 0) {
              this.errorcustAptDate = false;
              if (
                cntcNum.length === 10 &&
                this.removeDuplicateCharacters(cntcNum) > 1 &&
                this.checkInitialLetter(cntcNum)
              ) {
                var self = this;
                self.$store.commit("routeChange", "start");

                var custId = Number(self.customerId);

                const instance = axios.create({
                  baseURL: "https://uatgateway.supermoney.in/kycServices/",
                  // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
                  // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
                  // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
                  headers: { "content-type": "application/json" }
                });
                var data = {
                  data: [
                    {
                      source: "DIRECTOR_DETAIL",
                      data: {
                        name: self.custName,
                        shareholding_percentage: self.custShareHolding,
                        director_identification_no: self.custDIN,
                        appointment_date: self.custAptDate,
                        mobile_number: self.custcontactNo,
                        email: self.custEmailid
                      }
                    }
                  ],
                  customer_id: JSON.stringify(custId),
                  profile_id: self.viewProfileId,
                  kyc_verification_id: self.kycVerificationIdPrimary
                };

                // var timestamp = Math.round(+new Date() / 1000);

                instance
                  .post("CustomerKycDetails/", data)
                  .then(function (response) {
                    console.log(response);
                    const JSONData = response.data;

                    if (JSONData.successFlag == true) {
                      console.log("this is pan data");
                      self.basicDetAvail = true;
                      self.customerProfile();
                      self.$store.commit("routeChange", "end");
                    } else {
                      self.$store.commit("routeChange", "end");
                      self.alert = true;
                      self.alertMessage = JSONData.errorDetails.errorMessage;
                    }
                  })
                  .catch(function (error) {
                    // handle error
                    console.log("this is the error", error);
                    // self.alert = true;
                    // self.alertMessage = "Server Connection Failed";
                    self.$store.commit("routeChange", "end");
                  })
                  .finally(function () {
                    // always executed
                  });
              } else {
                this.errorcustcontactNo = true;
                this.errorcustcontactNoMsg = "Enter valid mobile no";
              }
            } else {
              this.errorcustAptDate = true;
              this.errorcustAptDateMsg = "Enter valid date";
            }
          } else {
            this.errorcustDIN = true;
            this.errorcustDINMsg = "Enter valid DIN";
          }
        } else {
          this.errorcustShareHolding = true;
          this.errorcustShareHoldingMsg = "Enter valid percentage";
        }
      } else {
        this.errorcustName = true;
        this.errorcustNameMsg = "Enter name";
      }
    },

    storeCustomerDataNew() {
      var tempCnt = Number(this.custcontactNoNew);
      var cntcNum = JSON.stringify(tempCnt);
      if (this.custNameNew.length > 0) {
        this.errorcustNameNew = false;
        if (
          Number(this.custShareHoldingNew <= 100) &&
          Number(this.custShareHoldingNew > 0)
        ) {
          console.log("this is the share holding", this.custShareHoldingNew);
          this.errorcustShareHoldingNew = false;
          if (this.custDINNew.length === 8) {
            this.errorcustDINNew = false;
            var today = this.$moment(new Date()).format("YYYY-MM-DD");
            if (this.custAptDateNew < today && this.custAptDateNew.length > 0) {
              this.errorcustAptDateNew = false;
              if (
                cntcNum.length === 10 &&
                this.removeDuplicateCharacters(cntcNum) > 1 &&
                this.checkInitialLetter(cntcNum)
              ) {
                var self = this;
                self.$store.commit("routeChange", "start");

                var custId = Number(self.customerId);

                const instance = axios.create({
                  baseURL: "https://uatgateway.supermoney.in/kycServices/",
                  // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //live
                  // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/mfInvestment/', //DEV
                  // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/MFInvestment/MFInvestment/', //live
                  headers: { "content-type": "application/json" }
                });
                var data = {
                  data: [
                    {
                      source: "DIRECTOR_DETAIL",
                      data: {
                        name: self.custNameNew,
                        shareholding_percentage: self.custShareHoldingNew,
                        director_identification_no: self.custDINNew,
                        appointment_date: self.custAptDateNew,
                        mobile_number: self.custcontactNoNew,
                        email: self.custEmailidNew
                      }
                    }
                  ],
                  customer_id: JSON.stringify(custId),
                  profile_id: self.secondaryProfileIdNew,
                  kyc_verification_id: self.kycVerifyIDNew
                };

                // var timestamp = Math.round(+new Date() / 1000);

                instance
                  .post("CustomerKycDetails/", data)
                  .then(function (response) {
                    console.log(response);
                    const JSONData = response.data;

                    if (JSONData.successFlag == true) {
                      console.log("this is pan data");
                      self.basicDetAvail = true;
                      self.customerProfile();
                      self.showOnceBtn = true;
                      self.$store.commit("routeChange", "end");
                    } else {
                      self.$store.commit("routeChange", "end");
                      self.alert = true;
                      self.alertMessage = JSONData.errorDetails.errorMessage;
                    }
                  })
                  .catch(function (error) {
                    // handle error
                    console.log("this is the error", error);
                    // self.alert = true;
                    // self.alertMessage = "Server Connection Failed";
                    self.$store.commit("routeChange", "end");
                  })
                  .finally(function () {
                    // always executed
                  });
              } else {
                this.errorcustcontactNoNew = true;
                this.errorcustcontactNoMsgNew = "Enter valid mobile no";
              }
            } else {
              this.errorcustAptDateNew = true;
              this.errorcustAptDateMsgNew = "Enter valid date";
            }
          } else {
            this.errorcustDINNew = true;
            this.errorcustDINMsgNew = "Enter valid DIN";
          }
        } else {
          this.errorcustShareHoldingNew = true;
          this.errorcustShareHoldingMsgNew = "Enter valid percentage";
        }
      } else {
        this.errorcustNameNew = true;
        this.errorcustNameMsgNew = "Enter name";
      }
    },

    // tabType(data)
    // {
    //   if(data === 'Proprietorship')
    //   {
    //     this.selectedTypeEntity = 'Proprietorship'
    //   }
    //   else if(data === 'Partnership')
    //   {
    //     this.selectedTypeEntity = 'Partnership'
    //   }
    //   else if(data === 'Company')
    //   {
    //     this.selectedTypeEntity = 'Company'
    //   }
    // },

    changeActive(value) {
      console.log("thisis rjwejknks", this.secondaryProfileList[value]);

      // console.log("this is the new vlauee",this.secondaryProfileList[3].newPartner)
      // for (var i = 0; i < this.secondaryProfileList.length; i++) {
      // console.log("this is the new added length",this.secondaryProfileList.length)
      // console.log("this is the old length",this.fixedProfileList.length)
      // if(this.secondaryProfileList.length == this.fixedProfileList.length)
      // {
      //   this.secondProfile = false
      // }
      // else
      // {
      //   this.secondProfile = true
      // }
      // }
      this.selectedButton = value;
      this.custEmailid = "";
      this.custcontactNo = "";
      this.custAptDate = "";
      this.custDIN = "";
      this.custShareHolding = "";
      this.custName = "";
      this.panNumber = "";
      this.panNo = "";
      this.currentAddressName = "";
      this.fileNameSet = "";
      this.errorPan = false;
      this.showOttheBusiProof = false;
      this.errorcustcontactNo = false;
      this.errorcustEmailid = false;
      this.errorcustAptDate = false;
      this.errorcustName = false;
      this.errorcustShareHolding = false;
      this.errorcustDIN = false;

      // this.$router.push({
      //   path: "/onboardingDirectorDetails",
      //   query: {
      //     data: this.customerId,
      //     borrowerId: this.borrowerId,
      //     companyName: this.companyName,
      //     authToken: this.authToken,
      //     loginId: this.loginId,
      //     custType: this.custType,
      //     applicationId:this.applicationId,
      //     selectedTypeEntity:this.selectedTypeEntity,
      //     secondProfile:this.secondaryProfileList[value],
      //     loginType:this.loginType,
      //
      //
      //   },
      //   props: true,
      // });

      if (
        this.secondaryProfileList[value] != -20 &&
        this.secondaryProfileList.length > 0
      ) {
        this.getKycVerificationID(this.secondaryProfileList[value]);
      } else {
        this.NewDirectorFlag = true;
      }

      console.log("this is the tab value", this.NewDirectorFlag);
    }
  },

  mounted() {
    this.$root.$on("a-far-away-event", () => {
      this.fetchProgramDetails();
      this.customerProfile();
      this.bankListFun();
      this.documentGroup();
    });

    //   this.$root.$on('typeSelected', (data) => {
    //     this.tabType(data)
    // });
  }
};
</script>
<style>
.btn-gradient-primary:active {
  background-image: linear-gradient(47deg, #7367f0, #7367f0) !important;
  color: #fff !important;
}

.btn-gradient-primary:focus {
  background-image: linear-gradient(47deg, #7367f0, #7367f0) !important;
  color: #fff !important;
}

.buttonActiveNew {
  border-bottom: 5px solid #7367f0;
  color: #7367f0;
}
</style>

<style>
.modalNew {
  display: none;
  /* Hidden by default */
  position: absolute;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 110px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 102%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.modal-contentNew {
  background-color: #fefefe;
  margin: 15% auto;
  /* 15% from the top and centered */

  border: 1px solid #888;
  width: 80%;
  /* Could be more or less, depending on screen size */
}

#addSupplierPOP>div>header.vs-popup--header {
  display: none;
}

#addSupplierPOP>div.vs-popup {
  width: fit-content !important;
  max-height: auto;
}

/* #autosuggest-autosuggest__results
{
    position: absolute;
    z-index: 999;
    background: white;
    border: 5px;
    padding: 10px;

} */

#addSupplierPOP>div>div.vs-popup--content.popup-example {
  padding: 0px;
}

#autosuggest__input {
  outline: none;
  position: relative;
  display: block;

  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  font-size: 12px;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 12px;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 200px;
  overflow-y: scroll;
  font-size: 12px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 5px;
  font-size: 12px;
}

#autosuggest ul:nth-child(1)>.autosuggest__results_title {
  border-top: none;
  font-size: 12px;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #7367f0;
  color: #ffffff;
  font-size: 12px;
}
</style>
<style lang="scss">
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
</style>
